export class AppConst {
  // ルーティング設定
  // サインイン
  static readonly ROUTING_SIGN_IN: string = 'sign-in';
  // サインアップ
  static readonly ROUTING_SIGN_UP: string = 'sign-up';
  // パスワード再設定メール送信
  static readonly ROUTING_PASSWORD_RESET_MAIL: string = 'password-reset-mail';
  // パスワード再設定
  static readonly ROUTING_PASSWORD_RESET: string = 'password-reset';
  // プロジェクト一覧
  static readonly ROUTING_TOP: string = 'project-list';
  // プロジェクト情報
  static readonly ROUTING_PROJECT: string = 'project';
  // ファイルアップロード画面
  static readonly ROUTING_UPLOADER: string = 'uploader';
  // ファイルアップロード(DL用)画面
  static readonly ROUTING_UPLOADER_DL: string = 'uploader-dl';
  // SPLATS情報
  static readonly ROUTING_SPLATS: string = 'splats';
  // 施設情報
  static readonly ROUTING_FACILITY: string = 'facility';
  // 施設職員情報
  static readonly ROUTING_FACILITY_USER: string = 'facility-user';
  // 建物情報
  static readonly ROUTING_HALL: string = 'hall';
  // フロア情報
  static readonly ROUTING_FLOOR: string = 'floor';
  // コンテンツ購入日次情報
  static readonly ROUTING_PURCHASE_CONTENT_DAILY: string = 'purchase-content-daily';
  // 展示情報
  static readonly ROUTING_EXHIBIT: string = 'exhibit';
  // 展示詳細情報
  static readonly ROUTING_EXHIBIT_DETAIL: string = 'exhibit-detail';
  // ランキング情報
  static readonly ROUTING_EXHIBIT_RANKING: string = 'exhibit-ranking';
  // 音声ファイルダウンロード
  static readonly ROUTING_VOICE_FILE_DOWNLOAD: string = 'voice-file-download';
  // 施設属性情報
  static readonly ROUTING_FACILITY_ATTRIBUTE: string = 'facility-attribute';
  // 展示属性情報
  static readonly ROUTING_EXHIBIT_ATTRIBUTE: string = 'exhibit-attribute';
  // 展示詳細属性情報
  static readonly ROUTING_EXHIBIT_DETAIL_ATTRIBUTE: string = 'exhibit-detail-attribute';
  // 予約設備属性情報
  static readonly ROUTING_RESERVATION_FACILITY_ATTRIBUTE: string = 'reservation-facility-attribute';
  // アップロードファイル属性情報
  static readonly ROUTING_UPLOADED_FILES_ATTRIBUTE: string = 'uploaded-files-attribute';
  // ユーザー情報
  static readonly ROUTING_USER: string = 'user';
  // 汎用テキスト情報
  static readonly ROUTING_GENERAL_TEXT: string = 'general-text';
  // 言語情報
  static readonly ROUTING_LANGUAGE: string = 'language';
  // 通知情報
  static readonly ROUTING_NOTICE: string = 'notice';
  // 通知管理
  static readonly ROUTING_NOTICE_MANAGE: string = 'notice-manage';
  // QR生成
  static readonly ROUTING_QRCODE: string = 'qrcode';
  // QR生成結果
  static readonly ROUTING_QRCODE_RESULT: string = 'qrcode-result';
  // URL生成結果
  static readonly ROUTING_URL_RESULT: string = 'url-result';
  // 予約設備
  static readonly ROUTING_RESERVATION_FACILITY: string = 'reservation-facility';
  // 予約設備：特別営業日
  static readonly ROUTING_RESERVATION_FACILITY_SPECIAL: string = 'reservation-facility-special';
  // 予約設問
  static readonly ROUTING_RESERVATION_QUESTION: string = 'reservation-question';
  // 予約状況
  static readonly ROUTING_RESERVATION: string = 'reservation';
  // 予約ダウンロード
  static readonly ROUTING_RESERVATION_DOWNLOAD: string = 'reservation-download';
  // 掲示板
  static readonly ROUTING_BOARD_THREAD: string = 'board-thread';
  static readonly ROUTING_BOARD_COMMENT: string = 'board-comment';
  // 設問情報
  static readonly ROUTING_QUESTION: string = 'question';
  // 設問セット
  static readonly ROUTING_QUEST_SET: string = 'quest-set';
  // 避難所情報
  static readonly ROUTING_SHELTER: string = 'shelter';
  // 入退場管理：イベント情報
  static readonly ROUTING_ENTRANCE_EXIT_EVENT: string = 'entrance-exit-event';
  // 入退場管理：イベント設問情報
  static readonly ROUTING_ENTRANCE_EXIT_QUESTION: string = 'entrance-exit-question';
  // 入退場管理：スタッフ情報
  static readonly ROUTING_ENTRANCE_EXIT_USER: string = 'entrance-exit-user';
  // 入退場管理：エントリー情報
  static readonly ROUTING_ENTRANCE_EXIT_ENTRY: string = 'entrance-exit-entry';
  // 入退場管理：日次入退場状況
  static readonly ROUTING_ENTRANCE_EXIT_TRANSIT_DAILY: string = 'entrance-exit-transit-daily';
  // 入退場管理：展示来場状況ダウンロード
  static readonly ROUTING_ENTRANCE_EXIT_EXHIBIT_TRANSIT_DOWNLOAD: string = 'entrance-exit-exhibit-transit-download';

  // アンケートダウンロードファイル作成
  static readonly ROUTING_ENQUETE: string = 'enquete';
  // オンラインマニュアル
  static readonly ROUTING_MANUAL: string = 'manual';
  static readonly ROUTING_MANUAL_INDEX: string = 'index';
  // オンラインマニュアル - TOP
  static readonly ROUTING_MANUAL_TOP: string = 'top';
  static readonly ROUTING_MANUAL_TOP_DIALOG: string = 'top-dialog';
  // オンラインマニュアル - プロジェクト情報
  static readonly ROUTING_MANUAL_PROJECT: string = 'project';
  static readonly ROUTING_MANUAL_PROJECT_DIALOG: string = 'project-dialog';
  // オンラインマニュアル - SPLATS情報
  static readonly ROUTING_MANUAL_SPLATS: string = 'splats';
  // オンラインマニュアル - ユーザー情報
  static readonly ROUTING_MANUAL_USER: string = 'user';
  static readonly ROUTING_MANUAL_USER_DIALOG: string = 'user-dialog';
  // オンラインマニュアル - ファイルアップロード画面
  static readonly ROUTING_MANUAL_UPLOADER: string = 'uploader';
  // オンラインマニュアル - ファイルアップロード画面（プレゼント用）
  static readonly ROUTING_MANUAL_UPLOADER_DL: string = 'uploader-dl';
  // オンラインマニュアル - 施設情報
  static readonly ROUTING_MANUAL_FACILITY: string = 'facility';
  static readonly ROUTING_MANUAL_FACILITY_DIALOG: string = 'facility-dialog';
  // オンラインマニュアル - 建物情報
  static readonly ROUTING_MANUAL_HALL: string = 'hall';
  static readonly ROUTING_MANUAL_HALL_DIALOG: string = 'hall-dialog';
  // オンラインマニュアル - フロア情報
  static readonly ROUTING_MANUAL_FLOOR: string = 'floor';
  static readonly ROUTING_MANUAL_FLOOR_DIALOG: string = 'floor-dialog';
  // オンラインマニュアル - 展示情報
  static readonly ROUTING_MANUAL_EXHIBIT: string = 'exhibit';
  static readonly ROUTING_MANUAL_EXHIBIT_DIALOG: string = 'exhibit-dialog';
  static readonly ROUTING_MANUAL_EXHIBIT_DETAIL: string = 'exhibit-detail';
  static readonly ROUTING_MANUAL_EXHIBIT_DETAIL_DIALOG: string = 'exhibit-detail-dialog';
  static readonly ROUTING_MANUAL_EXHIBIT_RANKING: string = 'exhibit-ranking';
  static readonly ROUTING_MANUAL_VOICE_FILE_DOWNLOAD: string = 'voice-file-download';
  // オンラインマニュアル - 予約状況
  static readonly ROUTING_MANUAL_RESERVATION: string = 'reservation';
  static readonly ROUTING_MANUAL_RESERVATION_DIALOG: string = 'reservation-dialog';
  static readonly ROUTING_MANUAL_SELECT_RESERVATION_DIALOG: string = 'select-reservation-dialog';
  static readonly ROUTING_MANUAL_CONFIRM_RESERVATION_DIALOG: string = 'confirm-reservation-dialog';
  static readonly ROUTING_MANUAL_CONFIRM_RESERVATION_DETAIL_DIALOG: string = 'confirm-reservation-detail-dialog';
  // オンラインマニュアル - 予約設備情報
  static readonly ROUTING_MANUAL_RESERVATION_FACILITY: string = 'reservation-facility';
  static readonly ROUTING_MANUAL_RESERVATION_FACILITY_DIALOG: string = 'reservation-facility-dialog';
  // オンラインマニュアル - 設備予約状況：閲覧
  static readonly ROUTING_MANUAL_RESERVATION_FACILITY_RESERVATION: string = 'reservation-facility-reservation';
  // オンラインマニュアル - 予約設備：特別営業日
  static readonly ROUTING_MANUAL_RESERVATION_FACILITY_SPECIAL: string = 'reservation-facility-special';
  static readonly ROUTING_MANUAL_RESERVATION_FACILITY_SPECIAL_DIALOG: string = 'reservation-facility-special-dialog';
  // オンラインマニュアル - 予約設問
  static readonly ROUTING_MANUAL_RESERVATION_QUESTION: string = 'reservation-question';
  static readonly ROUTING_MANUAL_RESERVATION_QUESTION_DIALOG: string = 'reservation-question-dialog';
  static readonly ROUTING_MANUAL_RESERVATION_QNAME_DIALOG: string = 'reservation-qname-dialog';
  static readonly ROUTING_MANUAL_RESERVATION_QCOMP_DIALOG: string = 'reservation-qcomp-dialog';
  static readonly ROUTING_MANUAL_RESERVATION_QITEM_DIALOG: string = 'reservation-qitem-dialog';
  // オンラインマニュアル - 予約ダウンロード
  static readonly ROUTING_MANUAL_RESERVATION_DOWNLOAD: string = 'reservation-download';
  // オンラインマニュアル - 予約ダウンロードファイル作成ダイアログ
  static readonly ROUTING_MANUAL_RESERVATION_DOWNLOAD_DIALOG: string = 'reservation-download-dialog';
  // オンラインマニュアル - 施設属性情報
  static readonly ROUTING_MANUAL_FACILITY_ATTRIBUTE: string = 'facility-attribute';
  static readonly ROUTING_MANUAL_FACILITY_ATTRIBUTE_DIALOG: string = 'facility-attribute-dialog';
  // オンラインマニュアル - 展示属性情報
  static readonly ROUTING_MANUAL_EXHIBIT_ATTRIBUTE: string = 'exhibit-attribute';
  static readonly ROUTING_MANUAL_EXHIBIT_ATTRIBUTE_DIALOG: string = 'exhibit-attribute-dialog';
  // オンラインマニュアル - 展示詳細属性情報
  static readonly ROUTING_MANUAL_EXHIBIT_DETAIL_ATTRIBUTE: string = 'exhibit-detail-attribute';
  static readonly ROUTING_MANUAL_EXHIBIT_DETAIL_ATTRIBUTE_DIALOG: string = 'exhibit-detail-attribute-dialog';
  // オンラインマニュアル - 予約設備属性情報
  static readonly ROUTING_MANUAL_RESERVATION_FACILITY_ATTRIBUTE: string = 'reservation-facility-attribute';
  static readonly ROUTING_MANUAL_RESERVATION_FACILITY_ATTRIBUTE_DIALOG: string = 'reservation-facility-attribute-dialog';
  // オンラインマニュアル - 通知情報
  static readonly ROUTING_MANUAL_NOTICE: string = 'notice';
  // オンラインマニュアル - 本番反映
  static readonly ROUTING_MANUAL_REFLECT_DATA: string = 'reflect-data';
  // オンラインマニュアル - 言語選択
  static readonly ROUTING_MANUAL_SELECT_LANGUAGE: string = 'select-language';
  // オンラインマニュアル - アプリ表示名ダイアログ
  static readonly ROUTING_MANUAL_APPNAME_DIALOG: string = 'appname-dialog';
  // オンラインマニュアル - 名称ダイアログ
  static readonly ROUTING_MANUAL_NAME_DIALOG: string = 'name-dialog';
  // オンラインマニュアル - 詳細ダイアログ
  static readonly ROUTING_MANUAL_DESC_DIALOG: string = 'desc-dialog';
  // オンラインマニュアル - 住所ダイアログ
  static readonly ROUTING_MANUAL_ADDRESS_DIALOG: string = 'address-dialog';
  // オンラインマニュアル - コピーライトダイアログ
  static readonly ROUTING_MANUAL_COPYRIGHT_DIALOG: string = 'copyright-dialog';
  // オンラインマニュアル - プライバシーポリシーダイアログ
  static readonly ROUTING_MANUAL_POLICY_DIALOG: string = 'policy-dialog';
  // オンラインマニュアル - FAQダイアログ
  static readonly ROUTING_MANUAL_FAQ_DIALOG: string = 'faq-dialog';
  // オンラインマニュアル - Youtubeダイアログ
  static readonly ROUTING_MANUAL_YOUTUBE_DIALOG: string = 'youtube-dialog';
  // オンラインマニュアル - 外部リンクURLダイアログ
  static readonly ROUTING_MANUAL_URL_DIALOG: string = 'url-dialog';
  // オンラインマニュアル - ユーザー入力タイトルダイアログ
  static readonly ROUTING_MANUAL_USER_INPUT_TITLE_DIALOG: string = 'user-input-title-dialog';
  // オンラインマニュアル - メール送信タイトルダイアログ
  static readonly ROUTING_MANUAL_SEND_MAIL_TITLE_DIALOG: string = 'send-mail-title-dialog';
  // オンラインマニュアル - メール送信本文ダイアログ
  static readonly ROUTING_MANUAL_SEND_MAIL_MESSAGE_DIALOG: string = 'send-mail-message-dialog';
  // オンラインマニュアル - QR(URL)生成ページ選択
  static readonly ROUTING_MANUAL_QRCODE: string = 'qrcode';
  // オンラインマニュアル - QRコード生成結果
  static readonly ROUTING_MANUAL_QRCODE_RESULT: string = 'qrcode-result';
  // オンラインマニュアル - URL生成結果
  static readonly ROUTING_MANUAL_URL_RESULT: string = 'url-result';
  // オンラインマニュアル - 設問情報
  static readonly ROUTING_MANUAL_QUESTION: string = 'question';
  static readonly ROUTING_MANUAL_QUESTION_DIALOG: string = 'question-dialog';
  static readonly ROUTING_MANUAL_QUESTION_SORT_DIALOG: string = 'question-sort-dialog';
  static readonly ROUTING_MANUAL_QNAME_DIALOG: string = 'qname-dialog';
  static readonly ROUTING_MANUAL_QCOMP_DIALOG: string = 'qcomp-dialog';
  static readonly ROUTING_MANUAL_QITEM_DIALOG: string = 'qitem-dialog';
  // オンラインマニュアル - 設問セット
  static readonly ROUTING_MANUAL_QUEST_SET: string = 'quest-set';
  static readonly ROUTING_MANUAL_QUEST_SET_DIALOG: string = 'quest-set-dialog';
  // オンラインマニュアル - 避難所情報
  static readonly ROUTING_MANUAL_SHELTER: string = 'shelter';
  static readonly ROUTING_MANUAL_SHELTER_DIALOG: string = 'shelter-dialog';
  // オンラインマニュアル - アンケート結果ダウンロード
  static readonly ROUTING_MANUAL_ENQUETE: string = 'enquete';
  // オンラインマニュアル - アンケート結果ダウンロードファイル作成ダイアログ
  static readonly ROUTING_MANUAL_ENQUETE_DIALOG: string = 'enquete-dialog';
  // オンラインマニュアル - 掲示板
  static readonly ROUTING_MANUAL_BOARD_THREAD: string = 'board-thread';
  static readonly ROUTING_MANUAL_BOARD_THREAD_DIALOG: string = 'board-thread-dialog';
  static readonly ROUTING_MANUAL_BOARD_COMMENT: string = 'board-comment';
  static readonly ROUTING_MANUAL_BOARD_COMMENT_DIALOG: string = 'board-comment-dialog';
  // オンラインマニュアル - 施設職員情報
  static readonly ROUTING_MANUAL_FACILITY_USER: string = 'facility-user';
  static readonly ROUTING_MANUAL_FACILITY_USER_DIALOG: string = 'facility-user-dialog';
  // オンラインマニュアル - コンテンツ購入日次情報
  static readonly ROUTING_MANUAL_PURCHASE_CONTENT_DAILY: string = 'purchase-content-daily';
  static readonly ROUTING_MANUAL_SELECT_PURCHASE_CONTENT_DAILY_DIALOG: string = 'select-purchase-content-daily-dialog';
  // オンラインマニュアル - 入退場管理:イベント情報
  static readonly ROUTING_MANUAL_ENTRANCE_EXIT_EVENT: string = 'entrance-exit-event';
  // オンラインマニュアル - 入退場管理:イベント設問情報
  static readonly ROUTING_MANUAL_ENTRANCE_EXIT_QUESTION: string = 'entrance-exit-question';
  static readonly ROUTING_MANUAL_ENTRANCE_EXIT_QUESTION_DIALOG: string = 'entrance-exit-question-dialog';
  // オンラインマニュアル - 入退場管理:スタッフ情報
  static readonly ROUTING_MANUAL_ENTRANCE_EXIT_USER: string = 'entrance-exit-user';
  static readonly ROUTING_MANUAL_ENTRANCE_EXIT_USER_DIALOG: string = 'entrance-exit-user-dialog';
  // オンラインマニュアル - 入退場管理:エントリー情報
  static readonly ROUTING_MANUAL_ENTRANCE_EXIT_ENTRY: string = 'entrance-exit-entry';
  static readonly ROUTING_MANUAL_SELECT_ENTRANCE_EXIT_ENTRY_DIALOG: string = 'select-entrance-exit-entry-diaog';
  static readonly ROUTING_MANUAL_ENTRANCE_EXIT_ENTRY_DIALOG: string = 'entrance-exit-entry-diaog';
  static readonly ROUTING_MANUAL_ENTRANCE_EXIT_TRANSIT_DIALOG: string = 'entrance-exit-transit-diaog';
  // オンラインマニュアル - 入退場管理:日次入退場状況
  static readonly ROUTING_MANUAL_ENTRANCE_EXIT_TRANSIT_DAILY: string = 'entrance-exit-transit-daily';
  static readonly ROUTING_MANUAL_SELECT_ENTRANCE_EXIT_TRANSIT_DAILY_DIALOG: string = 'select-entrance-exit-transit-daily-dialog';
  static readonly ROUTING_MANUAL_ENTRANCE_EXIT_TRANSIT_DAILY_DIALOG: string = 'entrance-exit-transit-daily-dialog';
  // オンラインマニュアル - 入退場管理:展示来場状況ダウンロード
  static readonly ROUTING_MANUAL_ENTRANCE_EXIT_EXHIBIT_TRANSIT_DOWNLOAD: string = 'entrance-exit-exhibit-transit-download';
  static readonly ROUTING_MANUAL_ENTRANCE_EXIT_EXHIBIT_TRANSIT_DOWNLOAD_DIALOG: string = 'entrance-exit-exhibit-transit-download-dialog';

  // ルーティングリンク
  // サインイン
  static readonly ROUTING_LINK_SIGN_IN: string = `/${AppConst.ROUTING_SIGN_IN}`;
  // プロジェクト一覧
  static readonly ROUTING_LINK_TOP: string = `/${AppConst.ROUTING_TOP}`;
  // プロジェクト情報
  static readonly ROUTING_LINK_PROJECT: string = `/${AppConst.ROUTING_PROJECT}`;
  // ファイルアップロード画面
  static readonly ROUTING_LINK_UPLOADER: string = `/${AppConst.ROUTING_UPLOADER}`;
  // ファイルアップロード(DL用)画面
  static readonly ROUTING_LINK_UPLOADER_DL: string = `/${AppConst.ROUTING_UPLOADER_DL}`;
  // SPLATS情報画面
  static readonly ROUTING_LINK_SPLATS: string = `/${AppConst.ROUTING_SPLATS}`;
  // 施設情報
  static readonly ROUTING_LINK_FACILITY: string = `/${AppConst.ROUTING_FACILITY}`;
  // 施設：職員情報
  static readonly ROUTING_LINK_FACILITY_USER: string = `/${AppConst.ROUTING_FACILITY_USER}`;
  // 建物情報
  static readonly ROUTING_LINK_HALL: string = `/${AppConst.ROUTING_HALL}`;
  // フロア情報
  static readonly ROUTING_LINK_FLOOR: string = `/${AppConst.ROUTING_FLOOR}`;
  // コンテンツ購入日次情報
  static readonly ROUTING_LINK_PURCHASE_CONTENT_DAILY: string = `/${AppConst.ROUTING_PURCHASE_CONTENT_DAILY}`;

  // 展示情報
  static readonly ROUTING_LINK_EXHIBIT: string = `/${AppConst.ROUTING_EXHIBIT}`;
  // 展示詳細情報
  static readonly ROUTING_LINK_EXHIBIT_DETAIL: string = `/${AppConst.ROUTING_EXHIBIT_DETAIL}`;
  // ランキング情報
  static readonly ROUTING_LINK_EXHIBIT_RANKING: string = `/${AppConst.ROUTING_EXHIBIT_RANKING}`;
  // 音声ファイルダウンロード
  static readonly ROUTING_LINK_VOICE_FILE_DOWNLOAD: string = `/${AppConst.ROUTING_VOICE_FILE_DOWNLOAD}`;
  // 施設属性情報
  static readonly ROUTING_LINK_FACILITY_ATTRIBUTE: string = `/${AppConst.ROUTING_FACILITY_ATTRIBUTE}`;
  // 展示属性情報
  static readonly ROUTING_LINK_EXHIBIT_ATTRIBUTE: string = `/${AppConst.ROUTING_EXHIBIT_ATTRIBUTE}`;
  // 展示詳細属性情報
  static readonly ROUTING_LINK_EXHIBIT_DETAIL_ATTRIBUTE: string = `/${AppConst.ROUTING_EXHIBIT_DETAIL_ATTRIBUTE}`;
  // 予約設備属性情報
  static readonly ROUTING_LINK_RESERVATION_FACILITY_ATTRIBUTE: string = `/${AppConst.ROUTING_RESERVATION_FACILITY_ATTRIBUTE}`;
  // アップロードファイル属性情報
  static readonly ROUTING_LINK_UPLOADED_FILES_ATTRIBUTE: string = `/${AppConst.ROUTING_UPLOADED_FILES_ATTRIBUTE}`;
  // ユーザー情報
  static readonly ROUTING_LINK_USER: string = `/${AppConst.ROUTING_USER}`;
  // 汎用テキスト情報
  static readonly ROUTING_LINK_GENERAL_TEXT: string = `/${AppConst.ROUTING_GENERAL_TEXT}`;
  // 言語情報
  static readonly ROUTING_LINK_LANGUAGE: string = `/${AppConst.ROUTING_LANGUAGE}`;
  // 通知情報
  static readonly ROUTING_LINK_NOTICE: string = `/${AppConst.ROUTING_NOTICE}`;
  // 通知管理
  static readonly ROUTING_LINK_NOTICE_MANAGE: string = `/${AppConst.ROUTING_NOTICE_MANAGE}`;
  // QR生成
  static readonly ROUTING_LINK_QRCODE: string = `/${AppConst.ROUTING_QRCODE}`;
  // QR生成結果
  static readonly ROUTING_LINK_QRCODE_RESULT: string = `/${AppConst.ROUTING_QRCODE_RESULT}`;
  // URL生成結果
  static readonly ROUTING_LINK_URL_RESULT: string = `/${AppConst.ROUTING_URL_RESULT}`;
  // 予約設備
  static readonly ROUTING_LINK_RESERVATION_FACILITY: string = `/${AppConst.ROUTING_RESERVATION_FACILITY}`;
  // 予約設備：特別営業日
  static readonly ROUTING_LINK_RESERVATION_FACILITY_SPECIAL: string = `/${AppConst.ROUTING_RESERVATION_FACILITY_SPECIAL}`;
  // 予約設問
  static readonly ROUTING_LINK_RESERVATION_QUESTION: string = `/${AppConst.ROUTING_RESERVATION_QUESTION}`;
  // 予約状況
  static readonly ROUTING_LINK_RESERVATION: string = `/${AppConst.ROUTING_RESERVATION}`;
  // 予約ダウンロード
  static readonly ROUTING_LINK_RESERVATION_DOWNLOAD: string = `/${AppConst.ROUTING_RESERVATION_DOWNLOAD}`;
  // 掲示板
  static readonly ROUTING_LINK_BOARD_THREAD: string = `/${AppConst.ROUTING_BOARD_THREAD}`;
  static readonly ROUTING_LINK_BOARD_COMMENT: string = `/${AppConst.ROUTING_BOARD_COMMENT}`;
  // 設問情報
  static readonly ROUTING_LINK_QUESTION: string = `/${AppConst.ROUTING_QUESTION}`;
  // 設問セット
  static readonly ROUTING_LINK_QUEST_SET: string = `/${AppConst.ROUTING_QUEST_SET}`;
  // 避難所情報
  static readonly ROUTING_LINK_SHELTER: string = `/${AppConst.ROUTING_SHELTER}`;
  // アンケート結果ダウンロード
  static readonly ROUTING_LINK_ENQUETE: string = `/${AppConst.ROUTING_ENQUETE}`;
  // 入退場管理：イベント情報
  static readonly ROUTING_LINK_ENTRANCE_EXIT_EVENT: string = `/${AppConst.ROUTING_ENTRANCE_EXIT_EVENT}`;
  // 入退場管理：イベント設問情報
  static readonly ROUTING_LINK_ENTRANCE_EXIT_QUESTION: string = `/${AppConst.ROUTING_ENTRANCE_EXIT_QUESTION}`;
  // 入退場管理：スタッフ情報
  static readonly ROUTING_LINK_ENTRANCE_EXIT_USER: string = `/${AppConst.ROUTING_ENTRANCE_EXIT_USER}`;
  // 入退場管理：エントリー情報
  static readonly ROUTING_LINK_ENTRANCE_EXIT_ENTRY: string = `/${AppConst.ROUTING_ENTRANCE_EXIT_ENTRY}`;
  // 入退場管理：日次入退場状況
  static readonly ROUTING_LINK_ENTRANCE_EXIT_TRANSIT_DAILY: string = `/${AppConst.ROUTING_ENTRANCE_EXIT_TRANSIT_DAILY}`;
  // 入退場管理：展示来場状況ダウンロード
  static readonly ROUTING_LINK_ENTRANCE_EXIT_EXHIBIT_TRANSIT_DOWNLOAD: string = `/${AppConst.ROUTING_ENTRANCE_EXIT_EXHIBIT_TRANSIT_DOWNLOAD}`;
  // オンラインマニュアル
  static readonly ROUTING_LINK_MANUAL_INDEX: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_INDEX}`;
  // オンラインマニュアル - TOP
  static readonly ROUTING_LINK_MANUAL_TOP: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_TOP}`;
  static readonly ROUTING_LINK_MANUAL_TOP_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_TOP_DIALOG}`;
  // オンラインマニュアル - プロジェクト情報
  static readonly ROUTING_LINK_MANUAL_PROJECT: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_PROJECT}`;
  static readonly ROUTING_LINK_MANUAL_PROJECT_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_PROJECT_DIALOG}`;
  // オンラインマニュアル - SPLATS情報
  static readonly ROUTING_LINK_MANUAL_SPLATS: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_SPLATS}`;
  // オンラインマニュアル - ユーザー情報
  static readonly ROUTING_LINK_MANUAL_USER: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_USER}`;
  static readonly ROUTING_LINK_MANUAL_USER_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_USER_DIALOG}`;
  // オンラインマニュアル - ファイルアップロード画面
  static readonly ROUTING_LINK_MANUAL_UPLOADER: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_UPLOADER}`;
  // オンラインマニュアル - ファイルアップロード画面（プレゼント用）
  static readonly ROUTING_LINK_MANUAL_UPLOADER_DL: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_UPLOADER_DL}`;
  // オンラインマニュアル - 施設情報
  static readonly ROUTING_LINK_MANUAL_FACILITY: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_FACILITY}`;
  static readonly ROUTING_LINK_MANUAL_FACILITY_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_FACILITY_DIALOG}`;
  // オンラインマニュアル - 建物情報
  static readonly ROUTING_LINK_MANUAL_HALL: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_HALL}`;
  static readonly ROUTING_LINK_MANUAL_HALL_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_HALL_DIALOG}`;
  // オンラインマニュアル - フロア情報
  static readonly ROUTING_LINK_MANUAL_FLOOR: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_FLOOR}`;
  static readonly ROUTING_LINK_MANUAL_FLOOR_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_FLOOR_DIALOG}`;
  // オンラインマニュアル - 展示情報
  static readonly ROUTING_LINK_MANUAL_EXHIBIT: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_EXHIBIT}`;
  static readonly ROUTING_LINK_MANUAL_EXHIBIT_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_EXHIBIT_DIALOG}`;
  static readonly ROUTING_LINK_MANUAL_EXHIBIT_DETAIL: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_EXHIBIT_DETAIL}`;
  static readonly ROUTING_LINK_MANUAL_EXHIBIT_DETAIL_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_EXHIBIT_DETAIL_DIALOG}`;
  static readonly ROUTING_LINK_MANUAL_EXHIBIT_RANKING: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_EXHIBIT_RANKING}`;
  static readonly ROUTING_LINK_MANUAL_VOICE_FILE_DOWNLOAD: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_VOICE_FILE_DOWNLOAD}`;
  // オンラインマニュアル - 予約設備情報
  static readonly ROUTING_LINK_MANUAL_RESERVATION_FACILITY: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_RESERVATION_FACILITY}`;
  static readonly ROUTING_LINK_MANUAL_RESERVATION_FACILITY_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_RESERVATION_FACILITY_DIALOG}`;
  // オンラインマニュアル - 設備予約状況：閲覧
  static readonly ROUTING_LINK_MANUAL_RESERVATION_FACILITY_RESERVATION: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_RESERVATION_FACILITY_RESERVATION}`;
  // オンラインマニュアル - 予約設備（特別営業日）情報
  static readonly ROUTING_LINK_MANUAL_RESERVATION_FACILITY_SPECIAL: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_RESERVATION_FACILITY_SPECIAL}`;
  static readonly ROUTING_LINK_MANUAL_RESERVATION_FACILITY_SPECIAL_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_RESERVATION_FACILITY_SPECIAL_DIALOG}`;
  // オンラインマニュアル - 予約設問
  static readonly ROUTING_LINK_MANUAL_RESERVATION_QUESTION: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_RESERVATION_QUESTION}`;
  static readonly ROUTING_LINK_MANUAL_RESERVATION_QUESTION_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_RESERVATION_QUESTION_DIALOG}`;
  static readonly ROUTING_LINK_MANUAL_RESERVATION_QUESTION_SORT_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_QUESTION_SORT_DIALOG}`;
  static readonly ROUTING_LINK_MANUAL_RESERVATION_QNAME_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_RESERVATION_QNAME_DIALOG}`;
  static readonly ROUTING_LINK_MANUAL_RESERVATION_QCOMP_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_RESERVATION_QCOMP_DIALOG}`;
  static readonly ROUTING_LINK_MANUAL_RESERVATION_QITEM_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_RESERVATION_QITEM_DIALOG}`;
  // オンラインマニュアル - 予約状況
  static readonly ROUTING_LINK_MANUAL_RESERVATION: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_RESERVATION}`;
  static readonly ROUTING_LINK_MANUAL_RESERVATION_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_RESERVATION_DIALOG}`;
  static readonly ROUTING_LINK_MANUAL_SELECT_RESERVATION_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_SELECT_RESERVATION_DIALOG}`;
  static readonly ROUTING_LINK_MANUAL_CONFIRM_RESERVATION_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_CONFIRM_RESERVATION_DIALOG}`;
  static readonly ROUTING_LINK_MANUAL_CONFIRM_RESERVATION_DETAIL_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_CONFIRM_RESERVATION_DETAIL_DIALOG}`;
  // オンラインマニュアル - 予約ダウンロード
  static readonly ROUTING_LINK_MANUAL_RESERVATION_DOWNLOAD: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_RESERVATION_DOWNLOAD}`;
  // オンラインマニュアル - 予約ダウンロードファイル作成ダイアログ
  static readonly ROUTING_LINK_MANUAL_RESERVATION_DOWNLOAD_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_RESERVATION_DOWNLOAD_DIALOG}`;
  // オンラインマニュアル - 施設属性情報
  static readonly ROUTING_LINK_MANUAL_FACILITY_ATTRIBUTE: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_FACILITY_ATTRIBUTE}`;
  static readonly ROUTING_LINK_MANUAL_FACILITY_ATTRIBUTE_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_FACILITY_ATTRIBUTE_DIALOG}`;
  // オンラインマニュアル - 展示属性情報
  static readonly ROUTING_LINK_MANUAL_EXHIBIT_ATTRIBUTE: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_EXHIBIT_ATTRIBUTE}`;
  static readonly ROUTING_LINK_MANUAL_EXHIBIT_ATTRIBUTE_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_EXHIBIT_ATTRIBUTE_DIALOG}`;
  // オンラインマニュアル - 展示詳細属性情報
  static readonly ROUTING_LINK_MANUAL_EXHIBIT_DETAIL_ATTRIBUTE: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_EXHIBIT_DETAIL_ATTRIBUTE}`;
  static readonly ROUTING_LINK_MANUAL_EXHIBIT_DETAIL_ATTRIBUTE_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_EXHIBIT_DETAIL_ATTRIBUTE_DIALOG}`;
  // オンラインマニュアル - 予約設備属性情報
  static readonly ROUTING_LINK_MANUAL_RESERVATION_FACILITY_ATTRIBUTE: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_RESERVATION_FACILITY_ATTRIBUTE}`;
  static readonly ROUTING_LINK_MANUAL_RESERVATION_FACILITY_ATTRIBUTE_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_RESERVATION_FACILITY_ATTRIBUTE_DIALOG}`;
  // オンラインマニュアル - 通知情報
  static readonly ROUTING_LINK_MANUAL_NOTICE: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_NOTICE}`;
  // オンラインマニュアル - 本番反映
  static readonly ROUTING_LINK_MANUAL_REFLECT_DATA: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_REFLECT_DATA}`;
  // オンラインマニュアル - 言語選択
  static readonly ROUTING_LINK_MANUAL_SELECT_LANGUAGE: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_SELECT_LANGUAGE}`;
  // オンラインマニュアル - アプリ表示名ダイアログ
  static readonly ROUTING_LINK_MANUAL_APPNAME_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_APPNAME_DIALOG}`;
  // オンラインマニュアル - 名称ダイアログ
  static readonly ROUTING_LINK_MANUAL_NAME_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_NAME_DIALOG}`;
  // オンラインマニュアル - 詳細ダイアログ
  static readonly ROUTING_LINK_MANUAL_DESC_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_DESC_DIALOG}`;
  // オンラインマニュアル - 住所ダイアログ
  static readonly ROUTING_LINK_MANUAL_ADDRESS_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_ADDRESS_DIALOG}`;
  // オンラインマニュアル - コピーライトダイアログ
  static readonly ROUTING_LINK_MANUAL_COPYRIGHT_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_COPYRIGHT_DIALOG}`;
  // オンラインマニュアル - プライバシーポリシーダイアログ
  static readonly ROUTING_LINK_MANUAL_POLICY_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_POLICY_DIALOG}`;
  // オンラインマニュアル - FAQダイアログ
  static readonly ROUTING_LINK_MANUAL_FAQ_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_FAQ_DIALOG}`;
  // オンラインマニュアル - Youtubeダイアログ
  static readonly ROUTING_LINK_MANUAL_YOUTUBE_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_YOUTUBE_DIALOG}`;
  // オンラインマニュアル - 外部リンクURLダイアログ
  static readonly ROUTING_LINK_MANUAL_URL_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_URL_DIALOG}`;
  // オンラインマニュアル - ユーザー入力タイトルダイアログ
  static readonly ROUTING_LINK_MANUAL_USER_INPUT_TITLE_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_USER_INPUT_TITLE_DIALOG}`;
  // オンラインマニュアル - メール送信タイトルダイアログ
  static readonly ROUTING_LINK_MANUAL_SEND_MAIL_TITLE_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_SEND_MAIL_TITLE_DIALOG}`;
  // オンラインマニュアル - メール送信本文ダイアログ
  static readonly ROUTING_LINK_MANUAL_SEND_MAIL_MESSAGE_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_SEND_MAIL_MESSAGE_DIALOG}`;
  // オンラインマニュアル - QR(URL)生成ページ選択
  static readonly ROUTING_LINK_MANUAL_QRCODE: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_QRCODE}`;
  // オンラインマニュアル - QRコード生成結果
  static readonly ROUTING_LINK_MANUAL_QRCODE_RESULT: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_QRCODE_RESULT}`;
  // オンラインマニュアル - URL生成結果
  static readonly ROUTING_LINK_MANUAL_URL_RESULT: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_URL_RESULT}`;
  // オンラインマニュアル - 設問情報
  static readonly ROUTING_LINK_MANUAL_QUESTION: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_QUESTION}`;
  static readonly ROUTING_LINK_MANUAL_QUESTION_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_QUESTION_DIALOG}`;
  static readonly ROUTING_LINK_MANUAL_QUESTION_SORT_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_QUESTION_SORT_DIALOG}`;
  static readonly ROUTING_LINK_MANUAL_QNAME_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_QNAME_DIALOG}`;
  static readonly ROUTING_LINK_MANUAL_QCOMP_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_QCOMP_DIALOG}`;
  static readonly ROUTING_LINK_MANUAL_QITEM_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_QITEM_DIALOG}`;
  // オンラインマニュアル - 設問セット
  static readonly ROUTING_LINK_MANUAL_QUEST_SET: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_QUEST_SET}`;
  static readonly ROUTING_LINK_MANUAL_QUEST_SET_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_QUEST_SET_DIALOG}`;
  // オンラインマニュアル - 避難所情報
  static readonly ROUTING_LINK_MANUAL_SHELTER: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_SHELTER}`;
  static readonly ROUTING_LINK_MANUAL_SHELTER_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_SHELTER_DIALOG}`;
  // オンラインマニュアル - アンケート結果ダウンロード
  static readonly ROUTING_LINK_MANUAL_ENQUETE: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_ENQUETE}`;
  // オンラインマニュアル - アンケート結果ダウンロードファイル作成ダイアログ
  static readonly ROUTING_LINK_MANUAL_ENQUETE_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_ENQUETE_DIALOG}`;
  // オンラインマニュアル - 掲示板
  static readonly ROUTING_LINK_MANUAL_BOARD_THREAD: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_BOARD_THREAD}`;
  static readonly ROUTING_LINK_MANUAL_BOARD_THREAD_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_BOARD_THREAD_DIALOG}`;
  static readonly ROUTING_LINK_MANUAL_BOARD_COMMENT: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_BOARD_COMMENT}`;
  static readonly ROUTING_LINK_MANUAL_BOARD_COMMENT_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_BOARD_COMMENT_DIALOG}`;
  // オンラインマニュアル - 施設職員情報
  static readonly ROUTING_LINK_MANUAL_FACILITY_USER: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_FACILITY_USER}`;
  static readonly ROUTING_LINK_MANUAL_FACILITY_USER_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_FACILITY_USER_DIALOG}`;
  // オンラインマニュアル - コンテンツ購入日次情報
  static readonly ROUTING_LINK_MANUAL_PURCHASE_CONTENT_DAILY: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_PURCHASE_CONTENT_DAILY}`;
  static readonly ROUTING_LINK_MANUAL_SELECT_PURCHASE_CONTENT_DAILY_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_SELECT_PURCHASE_CONTENT_DAILY_DIALOG}`;
  // オンラインマニュアル - 入退場管理:イベント情報
  static readonly ROUTING_LINK_MANUAL_ENTRANCE_EXIT_EVENT: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_ENTRANCE_EXIT_EVENT}`;
  // オンラインマニュアル - 入退場管理:イベント設問情報
  static readonly ROUTING_LINK_MANUAL_ENTRANCE_EXIT_QUESTION: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_ENTRANCE_EXIT_QUESTION}`;
  static readonly ROUTING_LINK_MANUAL_ENTRANCE_EXIT_QUESTION_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_ENTRANCE_EXIT_QUESTION_DIALOG}`;
  // オンラインマニュアル - 入退場管理:スタッフ情報
  static readonly ROUTING_LINK_MANUAL_ENTRANCE_EXIT_USER: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_ENTRANCE_EXIT_USER}`;
  static readonly ROUTING_LINK_MANUAL_ENTRANCE_EXIT_USER_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_ENTRANCE_EXIT_USER_DIALOG}`;
  // オンラインマニュアル - 入退場管理:エントリー情報
  static readonly ROUTING_LINK_MANUAL_ENTRANCE_EXIT_ENTRY: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_ENTRANCE_EXIT_ENTRY}`;
  static readonly ROUTING_LINK_MANUAL_SELECT_ENTRANCE_EXIT_ENTRY_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_SELECT_ENTRANCE_EXIT_ENTRY_DIALOG}`;
  static readonly ROUTING_LINK_MANUAL_ENTRANCE_EXIT_ENTRY_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_ENTRANCE_EXIT_ENTRY_DIALOG}`;
  static readonly ROUTING_LINK_MANUAL_ENTRANCE_EXIT_TRANSIT_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_ENTRANCE_EXIT_TRANSIT_DIALOG}`;
  // オンラインマニュアル - 入退場管理:日次入退場状況
  static readonly ROUTING_LINK_MANUAL_ENTRANCE_EXIT_TRANSIT_DAILY: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_ENTRANCE_EXIT_TRANSIT_DAILY}`;
  static readonly ROUTING_LINK_MANUAL_SELECT_ENTRANCE_EXIT_TRANSIT_DAILY_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_SELECT_ENTRANCE_EXIT_TRANSIT_DAILY_DIALOG}`;
  static readonly ROUTING_LINK_MANUAL_ENTRANCE_EXIT_TRANSIT_DAILY_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_ENTRANCE_EXIT_TRANSIT_DAILY_DIALOG}`;
  // オンラインマニュアル - 入退場管理:展示来場状況ダウンロード
  static readonly ROUTING_LINK_MANUAL_ENTRANCE_EXIT_EXHIBIT_TRANSIT_DOWNLOAD: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_ENTRANCE_EXIT_EXHIBIT_TRANSIT_DOWNLOAD}`;
  static readonly ROUTING_LINK_MANUAL_ENTRANCE_EXIT_EXHIBIT_TRANSIT_DOWNLOAD_DIALOG: string = `/${AppConst.ROUTING_MANUAL}/${AppConst.ROUTING_MANUAL_ENTRANCE_EXIT_EXHIBIT_TRANSIT_DOWNLOAD_DIALOG}`;

  // ユーザ権限
  // 一般ユーザ
  static readonly MANAGE_USER_TYPE_USER: number = 1;
  // プロジェクト管理ユーザ
  static readonly MANAGE_USER_TYPE_MASTER: number = 2;
  // アドミンユーザ
  static readonly MANAGE_USER_TYPE_ADMIN: number = 9;
  static readonly USER_TYPES: Array<number> = [
    AppConst.MANAGE_USER_TYPE_USER,
    AppConst.MANAGE_USER_TYPE_MASTER,
    AppConst.MANAGE_USER_TYPE_ADMIN
  ];

  // データ変更属性
  // 登録処理
  static readonly DATA_CHANGE_TYPE_ADD: number = 1;
  // 更新処理
  static readonly DATA_CHANGE_TYPE_UPDATE: number = 2;
  // 削除処理
  static readonly DATA_CHANGE_TYPE_DELETE: number = 3;
  // 使用可能処理
  static readonly DATA_CHANGE_TYPE_ENABLE: number = 7;
  // 使用不可処理
  static readonly DATA_CHANGE_TYPE_DISABLE: number = 8;
  // 既読処理（通知情報用）
  static readonly DATA_CHANGE_TYPE_MARK: number = 11;
  // 未読処理（通知情報用）
  static readonly DATA_CHANGE_TYPE_UNMARK: number = 12;

  // APIステータスコード
  // 正常
  static readonly API_RET_SUCCESS: number = 0;
  // 入力引数不正
  static readonly API_RET_INVALID_INPUT: number = 1;
  // サーバ処理エラー
  static readonly API_RET_SERVER_ERROR: number = 100;
  // アクセストークン不正
  static readonly API_RET_INVALID_ACCESSTOKEN: number = 200;
  // 該当データがない
  static readonly API_RET_NOT_FOUND_DATA: number = 1001;
  // 該当データがある（登録時）
  static readonly API_RET_ALREADY_EXIST_DATA: number = 1002;
  // 利用中データがある（削除時）
  static readonly API_RET_IN_USE_DATA: number = 1003;
  // 更新権限なし
  static readonly API_RET_UPDATE_AUTHORITY: number = 1009;
  // 使用不可
  static readonly API_RET_NOT_ENABLED: number = 1010;
  // 空き予約枠なし
  static readonly API_RET_NOT_VACANT_RESERVATION: 1011;

  //GoogleMap
  //ズームレベル
  static readonly ZOOM_INITIAL_VALUE: number = 16;
  //緯度
  static readonly LATITUDE_INITIAL_VALUE: number = 35.68947254;
  //経度
  static readonly LONGITUDE_INITIAL_VALUE: number = 139.6917513;

  //ファイルアップロードのルートディレクトリ
  static readonly FILE_UPLOAD_ROOT_DIR_NAME: string = "manage-app";
  //イメージファイルアップロード先ディレクトリ
  static readonly IMAGE_FILE_UPLOAD_DIR_NAME: string = "imagefile";
  //音声ファイルアップロード先ディレクトリ
  static readonly VOICE_FILE_UPLOAD_DIR_NAME: string = "voicefile";
  //ファイルアップロード先ディレクトリ
  static readonly FILE_UPLOAD_DIR_NAME: string = "uploadfiles";
  //ファイルアップロード先(DL用)ディレクトリ
  static readonly FILE_UPLOAD_DL_DIR_NAME: string = "uploadfilesDL";

  //ファイルアップロードのルートディレクトリ
  static readonly FILE_UPLOAD_BOARD_DIR_NAME: string = "board";

  //画像ファイル拡張子
  static readonly IMAGE_FILE_EXTS = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'ico', 'jfif']

  //施設情報デフォルトテーマカラー
  static readonly DEFAULT_THEME_COLOR: string = "gray";

  //Firestoreコレクション
  static readonly FIRESTORE_PROJECTS: string = 'projects_stg';
  static readonly FIRESTORE_FACILITY_ATTR: string = 'facility_attributes_stg';
  static readonly FIRESTORE_EXHIBIT_ATTR: string = 'exhibit_attributes_stg';
  static readonly FIRESTORE_EXHIBIT_DETAIL_ATTR: string = 'exhibit_detail_attributes_stg';
  static readonly FIRESTORE_RESERVATION_FACILITY_ATTR: string = 'reservation_facility_attributes_stg';
  static readonly FIRESTORE_UPLOADED_FILES_ATTR: string = 'uploaded_files_attributes_stg';
  static readonly FIRESTORE_UPLOADED_FILES: string = 'uploaded_files_stg';
  static readonly FIRESTORE_FACILITIES: string = 'facilities_stg';
  static readonly FIRESTORE_HALLS: string = 'halls_stg';
  static readonly FIRESTORE_FLOORS: string = 'floors_stg';
  static readonly FIRESTORE_EXHIBITS: string = 'exhibits_stg';
  static readonly FIRESTORE_EXHIBIT_DETAILS: string = 'exhibit_details_stg';
  static readonly FIRESTORE_RESERVATION_FACILITIES: string = 'reservation_facilities_stg';
  static readonly FIRESTORE_RESERVATION_FACILITY_SPECIALS: string = 'reservation_facility_specials_stg';
  static readonly FIRESTORE_RESERVATIONS: string = 'reservations';
  static readonly FIRESTORE_RESERVATION_DOWNLOAD_FILES: string = 'reservation_download_files';
  static readonly FIRESTORE_EXHIBIT_RANKINGS: string = 'exhibit_rankings';
  static readonly FIRESTORE_GOOD_EXHIBITS: string = 'good_exhibits';
  static readonly FIRESTORE_SCHEDULE: string = 'reflect_data_schedule';
  static readonly FIRESTORE_NOTICES: string = 'notices';
  static readonly FIRESTORE_BOARD_THREAD: string = 'board_thread';
  static readonly FIRESTORE_BOARD_COMMENT: string = 'board_comment';
  static readonly FIRESTORE_QUESTIONS: string = 'questions';
  static readonly FIRESTORE_QUEST_SET: string = 'quest_set';
  static readonly FIRESTORE_RESERVATION_QUESTIONS: string = 'reservation_questions';
  static readonly FIRESTORE_SHELTERS: string = 'shelters';
  static readonly FIRESTORE_ENQUETE_DOWNLOAD_FILES: string = 'enquete_download_files';
  static readonly FIRESTORE_GENERAL_TEXTS: string = 'general_texts';
  static readonly FIRESTORE_FACILITY_USERS: string = 'facility_users';
  static readonly FIRESTORE_PURCHASE_CONTENT_DAILIIES: string = 'purchase_content_dailies';
  static readonly FIRESTORE_ENTRANCE_EXIT_USERS: string = 'entrance_exit_users';
  static readonly FIRESTORE_ENTRANCE_EXIT_EVENTS: string = 'entrance_exit_events_stg';
  static readonly FIRESTORE_ENTRANCE_EXIT_QUESTIONS: string = 'entrance_exit_questions';
  static readonly FIRESTORE_ENTRANCE_EXIT_ENTRIES: string = 'entrance_exit_entries';
  static readonly FIRESTORE_ENTRANCE_EXIT_TRANSITS: string = 'entrance_exit_transits';
  static readonly FIRESTORE_ENTRANCE_EXIT_TRANSIT_DAILIES: string = 'entrance_exit_transit_dailies';
  static readonly FIRESTORE_ENTRANCE_EXIT_EXHIBIT_TRANSIT_DOWNLOAD_FILES: string = 'entrance_exit_exhibit_transit_download_files';
  static readonly FIRESTORE_SPLATS: string = 'splats';

  //本番 → STG戻しフラグ（NOTE: trueにする事で、本番 → STGへデータコピーする）
  static readonly REVERT_FLAG: boolean = false;

  // 本番反映ステータス
  static readonly REFLECT_STATUS_NO_RESERVATION: number = 0;  // 予約未設定
  static readonly REFLECT_STATUS_RESERVED: number = 1;        // 予約済み
  static readonly REFLECT_STATUS_RUNNING: number = 2;         // 実行中
  static readonly REFLECT_STATUS_ERROR: number = 9;           // エラー

  // 日付表示形式
  static readonly FORMAT_DATE_YYYYMMDDHHMMSS_SLASH = 'YYYY/MM/DD HH:mm:ss';
  static readonly FORMAT_DATE_YYYYMMDDHHMMSS_PYPHEN = 'YYYY-MM-DD HH:mm:ss';
  static readonly FORMAT_DATE_YYYYMMDDHHMM_PYPHEN = 'YYYY-MM-DD HH:mm';
  static readonly FORMAT_DATE_YYYYMMDD_PYPHEN = 'YYYY-MM-DD';
  // 日付保持形式
  static readonly FORMAT_DATE_YYYYMMDDHHMMSS = 'YYYYMMDDHHmmss';
  static readonly FORMAT_DATE_YYYYMMDDHHMM = 'YYYYMMDDHHmm00';
  static readonly FORMAT_DATE_YYYYMMDD = 'YYYYMMDD';

  // 施設情報：機能の使用方法
  // 使用しない
  static readonly USE_FUNCTION_NOT_USED: string = 'not_used';
  // PC+スマホ
  static readonly USE_FUNCTION_PC_SP: string = 'pc_sp';
  // PCのみ
  static readonly USE_FUNCTION_PC: string = 'pc';
  // PCのみ
  static readonly USE_FUNCTION_SP: string = 'sp';
  static readonly USE_FUNCTIONS: Array<string> = [
    AppConst.USE_FUNCTION_NOT_USED,
    AppConst.USE_FUNCTION_PC_SP,
    AppConst.USE_FUNCTION_PC,
    AppConst.USE_FUNCTION_SP,
  ];

  // 設問：項目タイプ
  static readonly QUESTION_ITEM_TYPE_STRING: string = 'string';
  static readonly QUESTION_ITEM_TYPE_TEXTAREA: string = 'text-area';
  static readonly QUESTION_ITEM_TYPE_NUMBER: string = 'number';
  static readonly QUESTION_ITEM_TYPE_DATE: string = 'date';
  static readonly QUESTION_ITEM_TYPE_DATETIME: string = 'datetime';
  static readonly QUESTION_ITEM_TYPE_SELECT: string = 'select';
  static readonly QUESTION_ITEM_TYPE_CHECKBOX: string = 'checkbox';
  static readonly QUESTION_ITEM_TYPE_RADIO: string = 'radio';
  static readonly QUESTION_ITEM_TYPES = [
    this.QUESTION_ITEM_TYPE_STRING,
    this.QUESTION_ITEM_TYPE_TEXTAREA,
    this.QUESTION_ITEM_TYPE_NUMBER,
    // this.QUESTION_ITEM_TYPE_DATE,
    // this.QUESTION_ITEM_TYPE_DATETIME,
    this.QUESTION_ITEM_TYPE_SELECT,
    this.QUESTION_ITEM_TYPE_CHECKBOX,
    this.QUESTION_ITEM_TYPE_RADIO,
  ];

  // 設問：項目チェック
  static readonly QUESTION_ITEM_CHECK_REQUIRED: string = '01';
  static readonly QUESTION_ITEM_CHECK_NUMBER: string = '02';
  static readonly QUESTION_ITEM_CHECK_HALF_ALPHANUMERIC: string = '03';
  static readonly QUESTION_ITEM_CHECK_FULL: string = '04';
  static readonly QUESTION_ITEM_CHECK_FULL_KANA: string = '05';
  static readonly QUESTION_ITEM_CHECK_FULL_HIRA: string = '06';
  static readonly QUESTION_ITEM_CHECK_EMAIL: string = '07';
  static readonly QUESTION_ITEM_CHECK_URL: string = '08';
  static readonly QUESTION_ITEM_CHECK_TEL: string = '09';
  static readonly QUESTION_ITEM_CHECK_RANGE: string = '10';
  static readonly QUESTION_ITEM_CHECK_COL_COUNT: string = '11';

  // 施設情報：メニュー表示GoogleMAP範囲（施設の緯度経度からの半径500or1000m内はメニュー表示、その範囲外は非表示）
  // 常に表示
  static readonly MENU_DISP_MAP_RANGE_NONE: number = 0;
  // 200m以内
  static readonly MENU_DISP_MAP_RANGE_200: number = 200;
  // 500m以内
  static readonly MENU_DISP_MAP_RANGE_500: number = 500;
  // 1000m以内
  static readonly MENU_DISP_MAP_RANGE_1000: number = 1000;
  static readonly MENU_DISP_MAP_RANGES: Array<number> = [
    AppConst.MENU_DISP_MAP_RANGE_NONE,
    AppConst.MENU_DISP_MAP_RANGE_200,
    AppConst.MENU_DISP_MAP_RANGE_500,
    AppConst.MENU_DISP_MAP_RANGE_1000
  ];

  // 施設情報：GoogleMAP表示タイプ
  // 地図
  static readonly MAP_DISP_TYPE_MAP: string = 'map';
  // 航空写真
  static readonly MAP_DISP_TYPE_SATELLITE: string = 'satellite';
  static readonly MAP_DISP_TYPES: Array<string> = [
    AppConst.MAP_DISP_TYPE_MAP,
    AppConst.MAP_DISP_TYPE_SATELLITE
  ];
  // 施設情報：音声制御タイプ
  // 自動再生しない
  static readonly VOICE_CONTROL_TYPE_OFF: string = 'off';
  // 現在地更新時に10m範囲内の展示物がある場合に自動再生
  static readonly VOICE_CONTROL_TYPE_ON_CURRENT_10M: string = 'on_current_10m';
  // 現在地更新時に20m範囲内の展示物がある場合に自動再生
  static readonly VOICE_CONTROL_TYPE_ON_CURRENT_20M: string = 'on_current_20m';
  // 現在地更新時に50m範囲内の展示物がある場合に自動再生
  static readonly VOICE_CONTROL_TYPE_ON_CURRENT_50M: string = 'on_current_50m';
  static readonly VOICE_CONTROL_TYPES: Array<string> = [
    AppConst.VOICE_CONTROL_TYPE_OFF,
    AppConst.VOICE_CONTROL_TYPE_ON_CURRENT_10M,
    AppConst.VOICE_CONTROL_TYPE_ON_CURRENT_20M,
    AppConst.VOICE_CONTROL_TYPE_ON_CURRENT_50M
  ];
  // 施設情報：ピンタップ時の音声制御タイプ
  // 展示情報の音声を自動再生しない
  static readonly PIN_TAP_VOICE_CONTROL_TYPE_OFF: string = 'off';
  // 展示情報の音声を自動再生する
  static readonly PIN_TAP_VOICE_CONTROL_TYPE_ON: string = 'on';
  static readonly PIN_TAP_VOICE_CONTROL_TYPES: Array<string> = [
    AppConst.PIN_TAP_VOICE_CONTROL_TYPE_OFF,
    AppConst.PIN_TAP_VOICE_CONTROL_TYPE_ON
  ];

  // 建物・カテゴリ情報：メニュー表示タイプ
  // ガイドに表示する
  static readonly MENU_DISP_TYPE_GUIDE: number = 1;
  // メニューに表示する
  static readonly MENU_DISP_TYPE_MENU: number = 2;
  static readonly MENU_DISP_TYPES: Array<number> = [
    AppConst.MENU_DISP_TYPE_GUIDE,
    AppConst.MENU_DISP_TYPE_MENU
  ];

  // 番号（展示ID）入力タイプ
  // 半角数字
  static readonly KEYPAD_TYPE_TEL: string = 'tel';
  // 半角英数＋ハイフン
  static readonly KEYPAD_TYPE_TEXT: string ='text';
  static readonly KEYPAD_TYPES: Array<string> = [
    AppConst.KEYPAD_TYPE_TEL,
    AppConst.KEYPAD_TYPE_TEXT
  ];

  // 翻訳基本言語
  // 英語（イギリス）
  static readonly TRANS_BASE_LANG_EN: string = 'en';
  // 英語（アメリカ）
  static readonly TRANS_BASE_LANG_US: string ='en-US';
    // 日本語 #216
  static readonly TRANS_BASE_LANG_JA: string ='ja';
  static readonly TRANS_BASE_LANGS: Array<string> = [
    AppConst.TRANS_BASE_LANG_EN,
    AppConst.TRANS_BASE_LANG_US
  ];

  // 予約設備情報：予約方式
  // 先着順
  static readonly RESERVATION_METHOD_FIRST: number = 1;
  // 抽選
  static readonly RESERVATION_METHOD_LOTTERY: number = 2;
  // 保留
  static readonly RESERVATION_METHOD_ON_HOLD: number = 3;
  static readonly RESERVATION_METHODS: Array<number> = [
    AppConst.RESERVATION_METHOD_FIRST,
    AppConst.RESERVATION_METHOD_LOTTERY,
    AppConst.RESERVATION_METHOD_ON_HOLD
  ];

  // 予約設備情報：抽選方式
  // 自動
  static readonly LOTTERY_METHOD_AUTO: number = 1;
  // 手動
  static readonly LOTTERY_METHOD_MANUAL: number = 2;
  static readonly LOTTERY_METHODS: Array<number> = [
    AppConst.LOTTERY_METHOD_AUTO,
    AppConst.LOTTERY_METHOD_MANUAL
  ];

  // 予約設備情報：予約単位
  // 期間
  static readonly RESERVATION_UNIT_PERIOD: number = 1;
  // 時間枠
  static readonly RESERVATION_UNIT_TIME: number = 2;
  static readonly RESERVATION_UNITS: Array<number> = [
    AppConst.RESERVATION_UNIT_PERIOD,
    AppConst.RESERVATION_UNIT_TIME
  ];

  // 予約設備情報：X日前
  // 当日
  static readonly RESERVATION_NUMBER_DAY_00: number = 0;
  // X日前
  static readonly RESERVATION_NUMBER_DAY_01: number = 1;
  static readonly RESERVATION_NUMBER_DAY_02: number = 2;
  static readonly RESERVATION_NUMBER_DAY_03: number = 3;
  static readonly RESERVATION_NUMBER_DAY_04: number = 4;
  static readonly RESERVATION_NUMBER_DAY_05: number = 5;
  static readonly RESERVATION_NUMBER_DAY_06: number = 6;
  static readonly RESERVATION_NUMBER_DAY_07: number = 7;
  static readonly RESERVATION_NUMBER_DAY_08: number = 8;
  static readonly RESERVATION_NUMBER_DAY_09: number = 9;
  static readonly RESERVATION_NUMBER_DAY_10: number = 10;
  static readonly RESERVATION_NUMBER_DAY_11: number = 11;
  static readonly RESERVATION_NUMBER_DAY_12: number = 12;
  static readonly RESERVATION_NUMBER_DAY_13: number = 13;
  static readonly RESERVATION_NUMBER_DAY_14: number = 14;
  static readonly RESERVATION_NUMBER_DAY_15: number = 15;
  static readonly RESERVATION_NUMBER_DAY_16: number = 16;
  static readonly RESERVATION_NUMBER_DAY_17: number = 17;
  static readonly RESERVATION_NUMBER_DAY_18: number = 18;
  static readonly RESERVATION_NUMBER_DAY_19: number = 19;
  static readonly RESERVATION_NUMBER_DAY_20: number = 20;
  static readonly RESERVATION_NUMBER_DAY_21: number = 21;
  static readonly RESERVATION_NUMBER_DAY_22: number = 22;
  static readonly RESERVATION_NUMBER_DAY_23: number = 23;
  static readonly RESERVATION_NUMBER_DAY_24: number = 24;
  static readonly RESERVATION_NUMBER_DAY_25: number = 25;
  static readonly RESERVATION_NUMBER_DAY_26: number = 26;
  static readonly RESERVATION_NUMBER_DAY_27: number = 27;
  static readonly RESERVATION_NUMBER_DAY_28: number = 28;
  static readonly RESERVATION_NUMBER_DAY_29: number = 29;
  static readonly RESERVATION_NUMBER_DAY_30: number = 30;
  static readonly RESERVATION_NUMBER_DAY_31: number = 31;
  static readonly RESERVATION_NUMBER_DAY_32: number = 32;
  static readonly RESERVATION_NUMBER_DAY_33: number = 33;
  static readonly RESERVATION_NUMBER_DAY_34: number = 34;
  static readonly RESERVATION_NUMBER_DAY_35: number = 35;
  static readonly RESERVATION_NUMBER_DAY_36: number = 36;
  static readonly RESERVATION_NUMBER_DAY_37: number = 37;
  static readonly RESERVATION_NUMBER_DAY_38: number = 38;
  static readonly RESERVATION_NUMBER_DAY_39: number = 39;
  static readonly RESERVATION_NUMBER_DAY_40: number = 40;
  static readonly RESERVATION_NUMBER_DAY_41: number = 41;
  static readonly RESERVATION_NUMBER_DAY_42: number = 42;
  static readonly RESERVATION_NUMBER_DAY_43: number = 43;
  static readonly RESERVATION_NUMBER_DAY_44: number = 44;
  static readonly RESERVATION_NUMBER_DAY_45: number = 45;
  static readonly RESERVATION_NUMBER_DAY_46: number = 46;
  static readonly RESERVATION_NUMBER_DAY_47: number = 47;
  static readonly RESERVATION_NUMBER_DAY_48: number = 48;
  static readonly RESERVATION_NUMBER_DAY_49: number = 49;
  static readonly RESERVATION_NUMBER_DAY_50: number = 50;
  static readonly RESERVATION_NUMBER_DAY_51: number = 51;
  static readonly RESERVATION_NUMBER_DAY_52: number = 52;
  static readonly RESERVATION_NUMBER_DAY_53: number = 53;
  static readonly RESERVATION_NUMBER_DAY_54: number = 54;
  static readonly RESERVATION_NUMBER_DAY_55: number = 55;
  static readonly RESERVATION_NUMBER_DAY_56: number = 56;
  static readonly RESERVATION_NUMBER_DAY_57: number = 57;
  static readonly RESERVATION_NUMBER_DAY_58: number = 58;
  static readonly RESERVATION_NUMBER_DAY_59: number = 59;
  static readonly RESERVATION_NUMBER_DAY_60: number = 60;
  static readonly RESERVATION_NUMBER_DAY_61: number = 61;
  static readonly RESERVATION_NUMBER_DAY_62: number = 62;
  static readonly RESERVATION_NUMBER_DAY_63: number = 63;
  static readonly RESERVATION_NUMBER_DAY_64: number = 64;
  static readonly RESERVATION_NUMBER_DAY_65: number = 65;
  static readonly RESERVATION_NUMBER_DAY_66: number = 66;
  static readonly RESERVATION_NUMBER_DAY_67: number = 67;
  static readonly RESERVATION_NUMBER_DAY_68: number = 68;
  static readonly RESERVATION_NUMBER_DAY_69: number = 69;
  static readonly RESERVATION_NUMBER_DAY_70: number = 70;
  static readonly RESERVATION_NUMBER_DAY_71: number = 71;
  static readonly RESERVATION_NUMBER_DAY_72: number = 72;
  static readonly RESERVATION_NUMBER_DAY_73: number = 73;
  static readonly RESERVATION_NUMBER_DAY_74: number = 74;
  static readonly RESERVATION_NUMBER_DAY_75: number = 75;
  static readonly RESERVATION_NUMBER_DAY_76: number = 76;
  static readonly RESERVATION_NUMBER_DAY_77: number = 77;
  static readonly RESERVATION_NUMBER_DAY_78: number = 78;
  static readonly RESERVATION_NUMBER_DAY_79: number = 79;
  static readonly RESERVATION_NUMBER_DAY_80: number = 80;
  static readonly RESERVATION_NUMBER_DAY_81: number = 81;
  static readonly RESERVATION_NUMBER_DAY_82: number = 82;
  static readonly RESERVATION_NUMBER_DAY_83: number = 83;
  static readonly RESERVATION_NUMBER_DAY_84: number = 84;
  static readonly RESERVATION_NUMBER_DAY_85: number = 85;
  static readonly RESERVATION_NUMBER_DAY_86: number = 86;
  static readonly RESERVATION_NUMBER_DAY_87: number = 87;
  static readonly RESERVATION_NUMBER_DAY_88: number = 88;
  static readonly RESERVATION_NUMBER_DAY_89: number = 89;
  static readonly RESERVATION_NUMBER_DAY_90: number = 90;
  // X日前
  static readonly RESERVATION_NUMBER_DAYS: Array<number> = [
    AppConst.RESERVATION_NUMBER_DAY_00,
    AppConst.RESERVATION_NUMBER_DAY_01,
    AppConst.RESERVATION_NUMBER_DAY_02,
    AppConst.RESERVATION_NUMBER_DAY_03,
    AppConst.RESERVATION_NUMBER_DAY_04,
    AppConst.RESERVATION_NUMBER_DAY_05,
    AppConst.RESERVATION_NUMBER_DAY_06,
    AppConst.RESERVATION_NUMBER_DAY_07,
    AppConst.RESERVATION_NUMBER_DAY_08,
    AppConst.RESERVATION_NUMBER_DAY_09,
    AppConst.RESERVATION_NUMBER_DAY_10,
    AppConst.RESERVATION_NUMBER_DAY_11,
    AppConst.RESERVATION_NUMBER_DAY_12,
    AppConst.RESERVATION_NUMBER_DAY_13,
    AppConst.RESERVATION_NUMBER_DAY_14,
    AppConst.RESERVATION_NUMBER_DAY_15,
    AppConst.RESERVATION_NUMBER_DAY_16,
    AppConst.RESERVATION_NUMBER_DAY_17,
    AppConst.RESERVATION_NUMBER_DAY_18,
    AppConst.RESERVATION_NUMBER_DAY_19,
    AppConst.RESERVATION_NUMBER_DAY_20,
    AppConst.RESERVATION_NUMBER_DAY_21,
    AppConst.RESERVATION_NUMBER_DAY_22,
    AppConst.RESERVATION_NUMBER_DAY_23,
    AppConst.RESERVATION_NUMBER_DAY_24,
    AppConst.RESERVATION_NUMBER_DAY_25,
    AppConst.RESERVATION_NUMBER_DAY_26,
    AppConst.RESERVATION_NUMBER_DAY_27,
    AppConst.RESERVATION_NUMBER_DAY_28,
    AppConst.RESERVATION_NUMBER_DAY_29,
    AppConst.RESERVATION_NUMBER_DAY_30,
    AppConst.RESERVATION_NUMBER_DAY_31,
    AppConst.RESERVATION_NUMBER_DAY_32,
    AppConst.RESERVATION_NUMBER_DAY_33,
    AppConst.RESERVATION_NUMBER_DAY_34,
    AppConst.RESERVATION_NUMBER_DAY_35,
    AppConst.RESERVATION_NUMBER_DAY_36,
    AppConst.RESERVATION_NUMBER_DAY_37,
    AppConst.RESERVATION_NUMBER_DAY_38,
    AppConst.RESERVATION_NUMBER_DAY_39,
    AppConst.RESERVATION_NUMBER_DAY_40,
    AppConst.RESERVATION_NUMBER_DAY_41,
    AppConst.RESERVATION_NUMBER_DAY_42,
    AppConst.RESERVATION_NUMBER_DAY_43,
    AppConst.RESERVATION_NUMBER_DAY_44,
    AppConst.RESERVATION_NUMBER_DAY_45,
    AppConst.RESERVATION_NUMBER_DAY_46,
    AppConst.RESERVATION_NUMBER_DAY_47,
    AppConst.RESERVATION_NUMBER_DAY_48,
    AppConst.RESERVATION_NUMBER_DAY_49,
    AppConst.RESERVATION_NUMBER_DAY_50,
    AppConst.RESERVATION_NUMBER_DAY_51,
    AppConst.RESERVATION_NUMBER_DAY_52,
    AppConst.RESERVATION_NUMBER_DAY_53,
    AppConst.RESERVATION_NUMBER_DAY_54,
    AppConst.RESERVATION_NUMBER_DAY_55,
    AppConst.RESERVATION_NUMBER_DAY_56,
    AppConst.RESERVATION_NUMBER_DAY_57,
    AppConst.RESERVATION_NUMBER_DAY_58,
    AppConst.RESERVATION_NUMBER_DAY_59,
    AppConst.RESERVATION_NUMBER_DAY_60,
    AppConst.RESERVATION_NUMBER_DAY_61,
    AppConst.RESERVATION_NUMBER_DAY_62,
    AppConst.RESERVATION_NUMBER_DAY_63,
    AppConst.RESERVATION_NUMBER_DAY_64,
    AppConst.RESERVATION_NUMBER_DAY_65,
    AppConst.RESERVATION_NUMBER_DAY_66,
    AppConst.RESERVATION_NUMBER_DAY_67,
    AppConst.RESERVATION_NUMBER_DAY_68,
    AppConst.RESERVATION_NUMBER_DAY_69,
    AppConst.RESERVATION_NUMBER_DAY_70,
    AppConst.RESERVATION_NUMBER_DAY_71,
    AppConst.RESERVATION_NUMBER_DAY_72,
    AppConst.RESERVATION_NUMBER_DAY_73,
    AppConst.RESERVATION_NUMBER_DAY_74,
    AppConst.RESERVATION_NUMBER_DAY_75,
    AppConst.RESERVATION_NUMBER_DAY_76,
    AppConst.RESERVATION_NUMBER_DAY_77,
    AppConst.RESERVATION_NUMBER_DAY_78,
    AppConst.RESERVATION_NUMBER_DAY_79,
    AppConst.RESERVATION_NUMBER_DAY_80,
    AppConst.RESERVATION_NUMBER_DAY_81,
    AppConst.RESERVATION_NUMBER_DAY_82,
    AppConst.RESERVATION_NUMBER_DAY_83,
    AppConst.RESERVATION_NUMBER_DAY_84,
    AppConst.RESERVATION_NUMBER_DAY_85,
    AppConst.RESERVATION_NUMBER_DAY_86,
    AppConst.RESERVATION_NUMBER_DAY_87,
    AppConst.RESERVATION_NUMBER_DAY_88,
    AppConst.RESERVATION_NUMBER_DAY_89,
    AppConst.RESERVATION_NUMBER_DAY_90,
  ];
  static readonly RESERVATION_PAST_NUMBER_DAYS: Array<number> = [
    AppConst.RESERVATION_NUMBER_DAY_01,
    AppConst.RESERVATION_NUMBER_DAY_02,
    AppConst.RESERVATION_NUMBER_DAY_03,
    AppConst.RESERVATION_NUMBER_DAY_04,
    AppConst.RESERVATION_NUMBER_DAY_05,
    AppConst.RESERVATION_NUMBER_DAY_06,
    AppConst.RESERVATION_NUMBER_DAY_07,
    AppConst.RESERVATION_NUMBER_DAY_08,
    AppConst.RESERVATION_NUMBER_DAY_09,
    AppConst.RESERVATION_NUMBER_DAY_10,
    AppConst.RESERVATION_NUMBER_DAY_11,
    AppConst.RESERVATION_NUMBER_DAY_12,
    AppConst.RESERVATION_NUMBER_DAY_13,
    AppConst.RESERVATION_NUMBER_DAY_14,
    AppConst.RESERVATION_NUMBER_DAY_15,
    AppConst.RESERVATION_NUMBER_DAY_16,
    AppConst.RESERVATION_NUMBER_DAY_17,
    AppConst.RESERVATION_NUMBER_DAY_18,
    AppConst.RESERVATION_NUMBER_DAY_19,
    AppConst.RESERVATION_NUMBER_DAY_20,
    AppConst.RESERVATION_NUMBER_DAY_21,
    AppConst.RESERVATION_NUMBER_DAY_22,
    AppConst.RESERVATION_NUMBER_DAY_23,
    AppConst.RESERVATION_NUMBER_DAY_24,
    AppConst.RESERVATION_NUMBER_DAY_25,
    AppConst.RESERVATION_NUMBER_DAY_26,
    AppConst.RESERVATION_NUMBER_DAY_27,
    AppConst.RESERVATION_NUMBER_DAY_28,
    AppConst.RESERVATION_NUMBER_DAY_29,
    AppConst.RESERVATION_NUMBER_DAY_30,
    AppConst.RESERVATION_NUMBER_DAY_31,
    AppConst.RESERVATION_NUMBER_DAY_32,
    AppConst.RESERVATION_NUMBER_DAY_33,
    AppConst.RESERVATION_NUMBER_DAY_34,
    AppConst.RESERVATION_NUMBER_DAY_35,
    AppConst.RESERVATION_NUMBER_DAY_36,
    AppConst.RESERVATION_NUMBER_DAY_37,
    AppConst.RESERVATION_NUMBER_DAY_38,
    AppConst.RESERVATION_NUMBER_DAY_39,
    AppConst.RESERVATION_NUMBER_DAY_40,
    AppConst.RESERVATION_NUMBER_DAY_41,
    AppConst.RESERVATION_NUMBER_DAY_42,
    AppConst.RESERVATION_NUMBER_DAY_43,
    AppConst.RESERVATION_NUMBER_DAY_44,
    AppConst.RESERVATION_NUMBER_DAY_45,
    AppConst.RESERVATION_NUMBER_DAY_46,
    AppConst.RESERVATION_NUMBER_DAY_47,
    AppConst.RESERVATION_NUMBER_DAY_48,
    AppConst.RESERVATION_NUMBER_DAY_49,
    AppConst.RESERVATION_NUMBER_DAY_50,
    AppConst.RESERVATION_NUMBER_DAY_51,
    AppConst.RESERVATION_NUMBER_DAY_52,
    AppConst.RESERVATION_NUMBER_DAY_53,
    AppConst.RESERVATION_NUMBER_DAY_54,
    AppConst.RESERVATION_NUMBER_DAY_55,
    AppConst.RESERVATION_NUMBER_DAY_56,
    AppConst.RESERVATION_NUMBER_DAY_57,
    AppConst.RESERVATION_NUMBER_DAY_58,
    AppConst.RESERVATION_NUMBER_DAY_59,
    AppConst.RESERVATION_NUMBER_DAY_60,
    AppConst.RESERVATION_NUMBER_DAY_61,
    AppConst.RESERVATION_NUMBER_DAY_62,
    AppConst.RESERVATION_NUMBER_DAY_63,
    AppConst.RESERVATION_NUMBER_DAY_64,
    AppConst.RESERVATION_NUMBER_DAY_65,
    AppConst.RESERVATION_NUMBER_DAY_66,
    AppConst.RESERVATION_NUMBER_DAY_67,
    AppConst.RESERVATION_NUMBER_DAY_68,
    AppConst.RESERVATION_NUMBER_DAY_69,
    AppConst.RESERVATION_NUMBER_DAY_70,
    AppConst.RESERVATION_NUMBER_DAY_71,
    AppConst.RESERVATION_NUMBER_DAY_72,
    AppConst.RESERVATION_NUMBER_DAY_73,
    AppConst.RESERVATION_NUMBER_DAY_74,
    AppConst.RESERVATION_NUMBER_DAY_75,
    AppConst.RESERVATION_NUMBER_DAY_76,
    AppConst.RESERVATION_NUMBER_DAY_77,
    AppConst.RESERVATION_NUMBER_DAY_78,
    AppConst.RESERVATION_NUMBER_DAY_79,
    AppConst.RESERVATION_NUMBER_DAY_80,
    AppConst.RESERVATION_NUMBER_DAY_81,
    AppConst.RESERVATION_NUMBER_DAY_82,
    AppConst.RESERVATION_NUMBER_DAY_83,
    AppConst.RESERVATION_NUMBER_DAY_84,
    AppConst.RESERVATION_NUMBER_DAY_85,
    AppConst.RESERVATION_NUMBER_DAY_86,
    AppConst.RESERVATION_NUMBER_DAY_87,
    AppConst.RESERVATION_NUMBER_DAY_88,
    AppConst.RESERVATION_NUMBER_DAY_89,
    AppConst.RESERVATION_NUMBER_DAY_90,
  ];

  // 予約設備情報：特別日タイプ
  // 休日
  static readonly RESERVATION_SPECIAL_DATE_TYPE_HOLIDAY: number = 1;
  // 特別営業日
  static readonly RESERVATION_SPECIAL_DATE_TYPE_SPECIAL: number = 2;
  static readonly RESERVATION_SPECIAL_DATE_TYPES: Array<number> = [
    AppConst.RESERVATION_SPECIAL_DATE_TYPE_HOLIDAY,
    AppConst.RESERVATION_SPECIAL_DATE_TYPE_SPECIAL
  ];

  static readonly HOURS: Array<string> = [
    '00','01','02','03','04','05','06','07','08','09',
    '10','11','12','13','14','15','16','17','18','19',
    '20','21','22','23'
  ];
  // static readonly MINUTES: Array<string> = [
  //   '00','01','02','03','04','05','06','07','08','09',
  //   '10','11','12','13','14','15','16','17','18','19',
  //   '20','21','22','23','24','25','26','27','28','29',
  //   '30','31','32','33','34','35','36','37','38','39',
  //   '40','41','42','43','44','45','46','47','48','49',
  //   '50','51','52','53','54','55','56','57','58','59'
  // ];
  static readonly MINUTES: Array<string> = [
    '00','05','10','15','20','25','30','35','40','45','50','55'
  ];
  // メール送信状況
  static readonly MAIL_SEND_STATUS_UNSEND:  number = 0;
  static readonly MAIL_SEND_STATUS_SENDING: number = 1;
  static readonly MAIL_SEND_STATUS_SUCCESS: number = 2;
  static readonly MAIL_SEND_STATUS_FAILURE: number = 3;
  static readonly MAIL_SEND_STATUS_CANCEL_SENDING: number = 4;
  static readonly MAIL_SEND_STATUSES: Array<number> = [
    AppConst.MAIL_SEND_STATUS_UNSEND,
    AppConst.MAIL_SEND_STATUS_SENDING,
    AppConst.MAIL_SEND_STATUS_CANCEL_SENDING,
    AppConst.MAIL_SEND_STATUS_SUCCESS,
    AppConst.MAIL_SEND_STATUS_FAILURE
  ];
  // 予約状況
  static readonly RESERVATION_STATUS_RECEPTION: number = 1;
  static readonly RESERVATION_STATUS_RECEPTION_TEXT: string = '受付中'; 
  static readonly RESERVATION_STATUS_COMPLETE: number = 2;
  static readonly RESERVATION_STATUS_COMPLETE_TEXT: string = '確定';
  static readonly RESERVATION_STATUS_CANCEL: number = 3;
  static readonly RESERVATION_STATUS_CANCEL_TEXT: string = '取消';
  static readonly RESERVATION_STATUS_LOST: number = 4;
  static readonly RESERVATION_STATUS_LOST_TEXT: string = '落選';

  static readonly RESERVATION_STATUSES: Array<number> = [
    AppConst.RESERVATION_STATUS_RECEPTION,
    AppConst.RESERVATION_STATUS_COMPLETE,
    AppConst.RESERVATION_STATUS_CANCEL,
    AppConst.RESERVATION_STATUS_LOST
  ];
  // メール通知モード
  // OFF:プロジェクト管理ユーザーへの通知メールを送信する
  // ON :各ステータスに従いプロジェクト管理ユーザーへの通知メールを送信する
  static readonly MAIL_NOTIFICATION_OFF = 0;
  static readonly MAIL_NOTIFICATION_ON_RECEPTION = 1;
  static readonly MAIL_NOTIFICATION_ON_COMPLETE = 2;
  static readonly MAIL_NOTIFICATION_ON_CANCEL = 3;
  static readonly MAIL_NOTIFICATION_ON_LOST = 4;
  // 性別
  static readonly GENDER_MALES: string = 'males';
  static readonly GENDER_FEMALES: string = 'females';
  static readonly GENDER_NOANSWERS: string = 'noAnswers';
  static readonly GENDERS: Array<string> = [
    AppConst.GENDER_MALES,
    AppConst.GENDER_FEMALES,
    AppConst.GENDER_NOANSWERS
  ];

  // CSV項目定義
  static readonly CSV_TYPE: string = '区分(1:追加/2:変更/3:削除)';
  static readonly CSV_KEY: string = 'key(区分2または3の場合必須)';
  static readonly CSV_ID: string = 'ID';
  static readonly CSV_ATTRIBUTE: string = '属性';
  static readonly CSV_ATTRIBUTE_ID: string = '属性ID';
  static readonly CSV_EXHIBIT_ID: string = '展示ID';
  static readonly CSV_RESERVATION_NO: string = '予約番号';
  static readonly CSV_RESERVATION_FACILITY_NAME: string = '予約施設名';
  static readonly CSV_RESERVATION_DATE: string = '予約日時';
  static readonly CSV_RESERVATION_CANCEL_DATE: string = 'キャンセル日時';
  static readonly CSV_RESERVATION_START_DATE: string = '利用日';
  static readonly CSV_RESERVATION_END_DATE: string = '利用日（延泊）';
  static readonly CSV_RESERVATION_TIMES: string = '利用時間';
  static readonly CSV_RESERVATION_STATUS: string = '予約状況';
  static readonly CSV_MAIL_ADDRESS: string = 'メールアドレス';
  static readonly CSV_MOBILE_PHONE_NO: string = '電話番号';
  static readonly CSV_FAMILY_NAME: string = '姓';
  static readonly CSV_FIRST_NAME: string = '名';
  static readonly CSV_SURNAME_CHINESE: string = '姓（漢字）';
  static readonly CSV_NAME_CHINESE: string = '名（漢字）';
  // CSV値定義
  static readonly CSV_INSERT: string = '1';
  static readonly CSV_UPDATE: string = '2';
  static readonly CSV_DELETE: string = '3';
  static readonly CSV_ON: string = 'ON';
  static readonly CSV_OFF: string = 'OFF';
  // 区分
  static readonly CSV_VAL_TYPE: Array<string> = [
    AppConst.CSV_INSERT,
    AppConst.CSV_UPDATE,
    AppConst.CSV_DELETE,
  ];
  // ON/OFF
  static readonly CSV_VAL_ONOFF: Array<string> = [
    AppConst.CSV_ON,
    AppConst.CSV_OFF,
  ];

  // 有効時間
  // X時間
  static readonly VALIDITY_PERIOD_HOUR_001: number = 1;
  static readonly VALIDITY_PERIOD_HOUR_002: number = 2;
  static readonly VALIDITY_PERIOD_HOUR_003: number = 3;
  static readonly VALIDITY_PERIOD_HOUR_004: number = 4;
  static readonly VALIDITY_PERIOD_HOUR_005: number = 5;
  static readonly VALIDITY_PERIOD_HOUR_006: number = 6;
  static readonly VALIDITY_PERIOD_HOUR_007: number = 7;
  static readonly VALIDITY_PERIOD_HOUR_008: number = 8;
  static readonly VALIDITY_PERIOD_HOUR_009: number = 9;
  static readonly VALIDITY_PERIOD_HOUR_010: number = 10;
  static readonly VALIDITY_PERIOD_HOUR_011: number = 11;
  static readonly VALIDITY_PERIOD_HOUR_012: number = 12;
  static readonly VALIDITY_PERIOD_HOUR_013: number = 13;
  static readonly VALIDITY_PERIOD_HOUR_014: number = 14;
  static readonly VALIDITY_PERIOD_HOUR_015: number = 15;
  static readonly VALIDITY_PERIOD_HOUR_016: number = 16;
  static readonly VALIDITY_PERIOD_HOUR_017: number = 17;
  static readonly VALIDITY_PERIOD_HOUR_018: number = 18;
  static readonly VALIDITY_PERIOD_HOUR_019: number = 19;
  static readonly VALIDITY_PERIOD_HOUR_020: number = 20;
  static readonly VALIDITY_PERIOD_HOUR_021: number = 21;
  static readonly VALIDITY_PERIOD_HOUR_022: number = 22;
  static readonly VALIDITY_PERIOD_HOUR_023: number = 23;
  static readonly VALIDITY_PERIOD_HOUR_024: number = 24;
  static readonly VALIDITY_PERIOD_HOUR_048: number = 48;
  static readonly VALIDITY_PERIOD_HOUR_072: number = 72;
  static readonly VALIDITY_PERIOD_HOUR_096: number = 96;
  static readonly VALIDITY_PERIOD_HOUR_120: number = 120;
  static readonly VALIDITY_PERIOD_HOUR_144: number = 144;
  static readonly VALIDITY_PERIOD_HOUR_168: number = 168;

  static readonly VALIDITY_PERIODS: Array<number> = [
    AppConst.VALIDITY_PERIOD_HOUR_001,
    AppConst.VALIDITY_PERIOD_HOUR_002,
    AppConst.VALIDITY_PERIOD_HOUR_003,
    AppConst.VALIDITY_PERIOD_HOUR_004,
    AppConst.VALIDITY_PERIOD_HOUR_005,
    AppConst.VALIDITY_PERIOD_HOUR_006,
    AppConst.VALIDITY_PERIOD_HOUR_007,
    AppConst.VALIDITY_PERIOD_HOUR_008,
    AppConst.VALIDITY_PERIOD_HOUR_009,
    AppConst.VALIDITY_PERIOD_HOUR_010,
    AppConst.VALIDITY_PERIOD_HOUR_011,
    AppConst.VALIDITY_PERIOD_HOUR_012,
    AppConst.VALIDITY_PERIOD_HOUR_013,
    AppConst.VALIDITY_PERIOD_HOUR_014,
    AppConst.VALIDITY_PERIOD_HOUR_015,
    AppConst.VALIDITY_PERIOD_HOUR_016,
    AppConst.VALIDITY_PERIOD_HOUR_017,
    AppConst.VALIDITY_PERIOD_HOUR_018,
    AppConst.VALIDITY_PERIOD_HOUR_019,
    AppConst.VALIDITY_PERIOD_HOUR_020,
    AppConst.VALIDITY_PERIOD_HOUR_021,
    AppConst.VALIDITY_PERIOD_HOUR_023,
    AppConst.VALIDITY_PERIOD_HOUR_024,
    AppConst.VALIDITY_PERIOD_HOUR_048,
    AppConst.VALIDITY_PERIOD_HOUR_072,
    AppConst.VALIDITY_PERIOD_HOUR_096,
    AppConst.VALIDITY_PERIOD_HOUR_120,
    AppConst.VALIDITY_PERIOD_HOUR_144,
    AppConst.VALIDITY_PERIOD_HOUR_168,
  ];

  // Angular Material Icons
  // https://fonts.google.com/icons
  // Action
  static readonly ANGULAR_MATERIAL_ICONS_ACTION = [
    'search', 'home', 'account_circle', 'settings', 'done', 'info', 'check_circle', 'delete', 'visibility', 'shopping_cart',
    'favorite', 'description', 'logout', 'favorite_border', 'lock', 'schedule', 'language', 'help_outline', 'face', 'verified',
    'manage_accounts', 'thumb_up', 'filter_alt', 'event', 'fingerprint', 'dashboard', 'list', 'check_circle_outline', 'visibility_off', 'login',
    'calendar_today', 'highlight_off', 'help', 'paid', 'task_alt', 'question_answer', 'date_range', 'article', 'open_in_new', 'shopping_bag',
    'lightbulb', 'credit_card', 'perm_identity', 'history', 'trending_up', 'account_balance', 'delete_outline', 'verified_user', 'fact_check', 'report_problem',
    'assignment', 'star_rate', 'arrow_right_alt', 'account_balance_wallet', 'calendar_month', 'autorenew', 'build', 'view_list', 'store', 'work',
    'print', 'analytics', 'delete_forever', 'today', 'admin_panel_settings', 'lock_open', 'watch_later', 'grade', 'update', 'savings',
    'room', 'code', 'add_shopping_cart', 'contact_support', 'receipt', 'power_settings_new', 'done_all', 'pets', 'explore', 'bookmark',
    'account_box', 'note_add', 'reorder', 'pending_actions', 'bookmark_border', 'shopping_basket', 'payment', 'launch', 'drag_indicator', 'supervisor_account',
    'touch_app', 'pending', 'zoom_in', 'assessment', 'leaderboard', 'thumb_up_off_alt', 'open_in_full', 'done_outline', 'preview', 'assignment_ind',
    'published_with_changes', 'exit_to_app', 'card_giftcard', 'view_in_ar', 'feedback', 'tips_and_updates', 'label', 'swap_horiz', 'timeline', 'work_outline',
    'stars', 'assignment_turned_in', 'sync_alt', 'dns', 'flight_takeoff', 'alarm', 'space_dashboard', 'contact_page', 'cached', 'bug_report',
    'book', 'translate', 'gavel', 'pan_tool', 'edit_calendar', 'supervised_user_circle', 'rocket_launch', 'minimize', 'question_mark', 'extension',
    'android', 'accessibility', 'get_app', 'record_voice_over', 'add_task', 'hourglass_empty', 'help_center', 'trending_flat', 'rule', 'accessibility_new',
    'thumb_down', 'ads_click', 'sticky_note_2', 'settings_applications', 'source', 'swap_vert', 'find_in_page', 'dashboard_customize', 'support', 'redeem',
    'loyalty', 'close_fullscreen', 'flutter_dash', 'announcement', 'arrow_circle_right', 'view_headline', 'restore', 'dangerous', 'currency_exchange', 'euro_symbol',
    'sensors', 'group_work', 'table_view', 'compare_arrows', 'disabled_by_default', 'subject', 'privacy_tip', 'nightlight_round', 'https', 'toc',
    'bookmarks', 'arrow_circle_up', 'track_changes', 'input', 'view_module', 'api', 'copyright', 'grading', 'query_builder', 'perm_media',
    'build_circle', 'perm_contact_calendar', 'zoom_out', 'settings_phone', 'info_outline', 'backup', 'open_with', 'circle_notifications', 'perm_phone_msg', 'speaker_notes',
    'wysiwyg', 'card_membership', 'label_important', 'book_online', 'file_present', 'arrow_circle_down', 'pageview', 'percent', 'upgrade', '3d_rotation',
    'change_history', 'trending_down', 'integration_instructions', 'accessible', 'class', 'swipe', 'g_translate', 'settings_accessibility', 'expand', 'arrow_circle_left',
    'settings_backup_restore', 'production_quantity_limits', 'offline_bolt', 'aspect_ratio', 'view_column', 'model_training', 'donut_large', 'segment', 'alarm_on', 'calendar_view_month',
    'schedule_send', 'maximize', 'settings_ethernet', 'thumbs_up_down', 'bookmark_add', 'theaters', 'view_agenda', 'thumb_down_off_alt', 'important_devices', 'unpublished',
    'system_update_alt', 'opacity', 'commute', 'open_in_browser', 'invert_colors', 'no_accounts', 'addchart', 'history_toggle_off', 'shopping_cart_checkout', 'view_week',
    'youtube_searched_for', 'tour', 'hide_source', 'search_off', 'bookmark_added', 'not_started', 'shop', 'mark_as_unread', 'plagiarism', 'settings_input_antenna',
    'filter_alt_off', 'turned_in', 'assignment_return', 'flight_land', 'balance', 'hotel_class', 'assignment_late', 'donut_small', 'contactless', 'highlight_alt',
    'saved_search', 'settings_input_component', 'view_carousel', 'rocket', 'view_quilt', 'all_inbox', 'settings_remote', 'anchor', 'edit_off', 'hourglass_full',
    'mediation', 'turned_in_not', 'fit_screen', 'remove_shopping_cart', 'flaky', 'toll', 'edit_document', 'terminal', 'swap_horizontal_circle', 'lock_clock',
    'view_sidebar', 'lock_reset', 'vertical_split', 'settings_voice', 'online_prediction', 'event_seat', 'data_exploration', 'next_plan', 'pregnant_woman', 'restore_from_trash',
    'camera_enhance', 'markunread_mailbox', 'dynamic_form', 'view_stream', 'tab', 'request_page', 'calendar_view_week', 'token', 'accessible_forward', 'remove_done',
    'smart_button', 'settings_power', 'add_to_drive', 'density_medium', 'outbox', 'try', 'card_travel', 'add_card', 'offline_pin', 'fax',
    'find_replace', 'work_history', 'assignment_returned', 'compress', 'calendar_view_day', 'rowing', 'chrome_reader_mode', 'edit_square', 'outlet', 'http',
    'generating_tokens', 'free_cancellation', 'settings_brightness', '123', 'new_label', 'backup_table', 'home_filled', 'spellcheck', 'alarm_add', 'assured_workload',
    'restore_page', 'credit_card_off', 'wifi_protected_setup', 'play_for_work', 'event_repeat', 'disabled_visible', 'noise_control_off', 'display_settings', 'settings_overscan', 'pan_tool_alt',
    'outbound', 'view_timeline', 'gif', 'manage_history', 'swap_vertical_circle', 'switch_access_shortcut', 'cancel_schedule_send', 'settings_input_composite', 'quickreply', 'satellite_alt',
    'view_day', 'webhook', 'comment_bank', 'line_weight', 'lock_outline', 'horizontal_split', 'lightbulb_outline', 'polymer', 'batch_prediction', 'picture_in_picture',
    'send_and_archive', 'troubleshoot', 'output', 'code_off', 'bookmark_remove', 'html', 'settings_bluetooth', 'shop_two', 'flip_to_front', 'outgoing_mail',
    'eject', 'speaker_notes_off', 'gif_box', 'alarm_off', 'perm_data_setting', 'switch_access_shortcut_add', 'settings_input_hdmi', 'hourglass_disabled', 'perm_scan_wifi', 'assignment_add',
    'sensors_off', 'work_off', 'settings_cell', 'app_blocking', 'picture_in_picture_alt', 'join_full', 'line_style', 'javascript', 'perm_device_information', 'abc',
    'app_shortcut', 'barcode_reader', 'update_disabled', 'subtitles_off', 'lightbulb_circle', 'swipe_left', 'filter_list_alt', 'voice_over_off', 'private_connectivity', 'join_inner',
    'swipe_right', 'install_desktop', 'settings_input_svideo', 'arrow_outward', 'swipe_up', 'flip_to_back', 'view_array', 'open_in_new_off', 'density_small', 'all_out',
    'shop_2', 'label_off', 'data_thresholding', 'tab_unselected', 'rounded_corner', 'commit', 'lock_person', 'text_rotate_vertical', 'view_kanban', 'explore_off',
    'install_mobile', 'css', 'text_rotation_none', 'spatial_audio_off', 'swipe_down', 'not_accessible', 'join_left', 'pin_invoke', 'pinch', 'noise_aware',
    'rebase_edit', 'swipe_vertical', 'extension_off', 'perm_camera_mic', 'view_cozy', 'join_right', 'pin_end', 'swipe_right_alt', 'text_rotate_up', 'browse_gallery',
    'text_rotation_angledown', 'php', 'text_rotation_angleup', 'label_important_outline', 'view_comfy_alt', 'text_rotation_down', 'add_home', 'view_compact_alt', 'network_ping', 'unfold_more_double',
    'swipe_down_alt', 'on_device_training', 'density_large', 'spatial_tracking', 'swipe_left_alt', 'spatial_audio', 'swipe_up_alt', 'unfold_less_double', 'width_full', 'repartition',
    'width_normal', 'transcribe', 'width_wide', 'hls_off', 'hls',
  ];

  // Navigation
  static readonly ANGULAR_MATERIAL_ICONS_NAVIGATION = [
    'close', 'menu', 'expand_more', 'arrow_back', 'chevron_right', 'arrow_forward_ios', 'arrow_back_ios', 'cancel', 'arrow_drop_down', 'more_vert',
    'arrow_forward', 'chevron_left', 'expand_less', 'check', 'more_horiz', 'refresh', 'apps', 'payments', 'arrow_upward', 'east',
    'campaign', 'arrow_back_ios_new', 'arrow_downward', 'arrow_right', 'menu_open', 'fullscreen', 'arrow_drop_up', 'unfold_more', 'double_arrow', 'maps_home_work',
    'west', 'expand_circle_down', 'arrow_left', 'south', 'north_east', 'north', 'home_work', 'first_page', 'fullscreen_exit', 'arrow_drop_down_circle',
    'last_page', 'unfold_less', 'subdirectory_arrow_right', 'legend_toggle', 'south_east', 'app_settings_alt', 'assistant_direction', 'subdirectory_arrow_left', 'north_west', 'waterfall_chart',
    'switch_left', 'south_west', 'pivot_table_chart', 'switch_right', 'apps_outage', 'offline_share', 'assistant_navigation', 'add_home_work',
  ];

  // Social
  static readonly ANGULAR_MATERIAL_ICONS_SOCIAL = [
    'person', 'notifications', 'groups', 'people', 'share', 'school', 'person_outline', 'person_add', 'public', 'emoji_events',
    'group', 'engineering', 'notifications_active', 'construction', 'people_alt', 'group_add', 'psychology', 'thumb_up_alt', 'health_and_safety', 'travel_explore',
    'water_drop', 'notifications_none', 'emoji_emotions', 'sports_esports', 'sentiment_very_satisfied', 'workspace_premium', 'location_city', 'ios_share', 'precision_manufacturing', 'sentiment_satisfied',
    'person_add_alt', 'science', 'military_tech', 'emoji_objects', 'history_edu', 'cake', 'sentiment_dissatisfied', 'handshake', 'sentiment_very_dissatisfied', 'emoji_people',
    'self_improvement', 'coronavirus', 'person_remove', 'poll', 'whatshot', 'sports_soccer', 'domain', 'recommend', 'mood', 'people_outline',
    'female', 'recycling', 'person_off', 'male', 'person_add_alt_1', 'sentiment_neutral', 'connect_without_contact', 'thumb_down_alt', 'waving_hand', 'back_hand',
    'hiking', 'architecture', 'real_estate_agent', 'notifications_off', 'masks', 'luggage', 'front_hand', 'vaccines', 'mood_bad', 'emoji_nature',
    'switch_account', 'compost', 'nights_stay', 'diversity_3', 'interests', 'king_bed', 'catching_pokemon', 'sports_basketball', 'notification_add', 'cruelty_free',
    'sports_kabaddi', 'man', 'sports', 'reduce_capacity', 'emoji_food_beverage', 'emoji_symbols', 'sick', 'emoji_transportation', 'heart_broken', 'cookie',
    'sports_tennis', 'add_reaction', 'elderly', 'wallet', 'diversity_1', 'transgender', 'woman', 'add_moderator', 'personal_injury', 'outdoor_grill',
    'deck', 'scale', 'follow_the_signs', 'social_distance', 'plus_one', 'fireplace', 'pix', 'clean_hands', 'piano', 'sports_motorsports',
    'surfing', 'sanitizer', 'sports_handball', 'hive', 'sports_baseball', 'groups_2', 'psychology_alt', 'edit_notifications', 'sports_volleyball', 'pages',
    'sports_football', 'diversity_2', 'downhill_skiing', 'kayaking', 'group_remove', 'public_off', 'co2', 'single_bed', 'remove_moderator', 'notifications_paused',
    'boy', 'skateboarding', 'domain_add', 'person_remove_alt_1', 'safety_divider', 'fitbit', 'group_off', 'sports_cricket', 'thunderstorm', 'sports_martial_arts',
    'sports_mma', 'groups_3', 'nordic_walking', 'sports_golf', 'girl', 'sports_gymnastics', 'paragliding', 'face_6', 'party_mode', 'snowboarding',
    '6_ft_apart', 'kitesurfing', 'face_3', 'snowshoeing', 'south_america', 'sports_hockey', 'ice_skating', 'elderly_woman', 'sports_rugby', 'person_2',
    'scoreboard', 'sledding', 'face_2', 'face_4', 'sign_language', 'cyclone', 'face_5', 'person_4', 'no_luggage', 'person_3',
    'flood', 'dew_point', 'scuba_diving', 'piano_off', 'severe_cold', 'tsunami', 'roller_skating', 'tornado', 'landslide', 'assist_walker',
    'woman_2', 'man_2', 'blind', '18_up_rating', 'volcano', 'no_adult_content', 'man_4', 'man_3',
  ];

  // Content
  static readonly ANGULAR_MATERIAL_ICONS_CONTENT = [
    'add', 'add_circle_outline', 'content_copy', 'add_circle', 'send', 'clear', 'save', 'mail', 'link', 'remove',
    'filter_list', 'inventory_2', 'inventory', 'insights', 'remove_circle_outline', 'sort', 'bolt', 'flag', 'reply', 'add_box',
    'remove_circle', 'push_pin', 'block', 'calculate', 'create', 'undo', 'how_to_reg', 'content_paste', 'report', 'file_copy',
    'backspace', 'shield', 'archive', 'save_alt', 'policy', 'change_circle', 'tag', 'redo', 'forward', 'content_cut',
    'outlined_flag', 'inbox', 'link_off', 'ballot', 'drafts', 'biotech', 'report_gmailerrorred', 'delete_sweep', 'stacked_bar_chart', 'markunread',
    'square_foot', 'add_link', 'stream', 'copy_all', 'dynamic_feed', 'where_to_vote', 'move_to_inbox', 'waves', 'content_paste_search', 'unarchive',
    'reply_all', 'select_all', 'low_priority', 'save_as', 'text_format', 'font_download', 'weekend', 'how_to_vote', 'upcoming', 'gesture',
    'attribution', 'flag_circle', 'content_paste_go', 'filter_list_off', 'next_week', 'content_paste_off', 'web_stories', 'report_off', 'deselect', 'font_download_off',
    'block_flipped',
  ];

  // Image
  static readonly ANGULAR_MATERIAL_ICONS_IMAGE = [
    'edit', 'navigate_next', 'photo_camera', 'image', 'tune', 'picture_as_pdf', 'receipt_long', 'circle', 'timer', 'auto_awesome',
    'auto_stories', 'collections', 'navigate_before', 'add_a_photo', 'palette', 'remove_red_eye', 'music_note', 'add_photo_alternate', 'wb_sunny', 'brush',
    'euro', 'flash_on', 'auto_fix_high', 'looks_one', 'control_point', 'style', 'adjust', 'straighten', 'photo_library', 'camera',
    'portrait', 'audiotrack', 'camera_alt', 'rotate_right', 'color_lens', 'grid_on', 'video_camera_front', 'crop_free', 'timelapse', 'currency_rupee',
    'landscape', 'slideshow', 'collections_bookmark', 'panorama_fish_eye', 'crop_square', 'looks_two', 'lens', 'looks_3', 'filter_vintage', 'compare',
    'filter_drama', 'image_search', 'healing', 'rotate_left', 'center_focus_strong', 'auto_awesome_motion', 'blur_on', 'crop', 'wb_incandescent', 'assistant',
    'face_retouching_natural', 'broken_image', 'flare', 'wb_cloudy', 'cases', 'filter_none', 'colorize', 'auto_fix_normal', 'crop_original', 'filter_center_focus',
    'brightness_4', 'nature_people', 'dehaze', 'photo', 'flash_off', 'tag_faces', 'auto_awesome_mosaic', 'brightness_6', 'details', 'brightness_5',
    'brightness_1', 'grain', 'flip_camera_android', 'flip', 'loupe', 'view_comfy', 'image_not_supported', 'flip_camera_ios', 'filter_1', 'bedtime',
    'movie_creation', 'add_to_photos', 'looks_4', 'panorama', 'animation', 'center_focus_weak', 'movie_filter', 'crop_din', 'currency_bitcoin', 'brightness_7',
    'control_point_duplicate', 'leak_add', 'filter', 'incomplete_circle', 'nature', 'view_compact', 'currency_yen', 'texture', 'timer_off', 'photo_size_select_actual',
    'video_camera_back', 'transform', 'contrast', 'looks_5', 'motion_photos_on', 'rotate_90_degrees_ccw', 'photo_camera_front', 'mic_external_on', 'wb_twilight', 'gradient',
    'currency_pound', 'assistant_photo', 'hide_image', 'exposure_plus_1', 'music_off', 'crop_16_9', 'exposure', 'thermostat_auto', 'filter_2', 'shutter_speed',
    'photo_album', 'filter_tilt_shift', 'hdr_strong', 'looks', 'looks_6', 'brightness_3', 'linked_camera', 'vrpano', 'blur_circular', 'crop_portrait',
    'flash_auto', 'motion_photos_auto', 'photo_filter', 'iso', 'brightness_2', 'photo_size_select_small', 'crop_7_5', 'rotate_90_degrees_cw', 'filter_hdr', 'tonality',
    'crop_rotate', 'photo_size_select_large', 'currency_ruble', 'exposure_zero', 'filter_3', 'camera_front', 'hdr_weak', 'crop_5_4', 'burst_mode', 'filter_frames',
    'logo_dev', 'camera_roll', 'blur_linear', 'filter_b_and_w', 'crop_landscape', 'crop_3_2', 'switch_camera', 'switch_video', 'filter_7', 'filter_4',
    'filter_9_plus', 'exposure_plus_2', 'wb_iridescent', 'grid_off', 'motion_photos_paused', 'photo_camera_back', 'monochrome_photos', 'auto_fix_off', 'filter_5', 'exposure_neg_1',
    'face_retouching_off', 'leak_remove', 'panorama_photosphere', 'filter_9', 'filter_8', 'timer_10', 'video_stable', 'filter_6', 'raw_on', 'motion_photos_off',
    'wb_shade', 'blur_off', 'motion_photos_pause', 'deblur', 'hdr_on', 'vignette', 'panorama_horizontal', '30fps_select', 'dirty_lens', 'image_aspect_ratio',
    'camera_rear', 'currency_yuan', 'currency_lira', 'timer_3', '60fps_select', 'panorama_wide_angle_select', '24mp', 'exposure_neg_2', 'autofps_select', 'panorama_horizontal_select',
    'panorama_photosphere_select', 'wb_auto', 'panorama_wide_angle', 'hdr_plus', 'panorama_vertical_select', 'mic_external_off', 'wb_twighlight', '12mp', 'currency_franc', 'panorama_vertical',
    'mp', 'hdr_enhanced_select', 'hevc', '18mp', '10mp', 'bedtime_off', 'raw_off', '23mp', 'hdr_off', '11mp',
    '20mp', '3mp', '5mp', '13mp', '15mp', '21mp', '16mp', '2mp', '17mp', '14mp',
    '19mp', '22mp', '4mp', '8mp', '7mp', '9mp', '6mp',
  ];
  
  // Communication
  static readonly ANGULAR_MATERIAL_ICONS_COMMUNICATION = [
    'email', 'location_on', 'call', 'phone', 'business', 'chat', 'mail_outline', 'list_alt', 'qr_code_scanner', 'vpn_key',
    'chat_bubble_outline', 'alternate_email', 'forum', 'chat_bubble', 'textsms', 'person_search', 'contact_mail', 'sentiment_satisfied_alt', 'qr_code', 'qr_code_2',
    'message', 'contacts', 'comment', 'key', 'import_contacts', 'app_registration', 'contact_phone', 'import_export', 'live_help', 'forward_to_inbox',
    'hourglass_bottom', 'hourglass_top', 'rss_feed', 'mark_email_read', 'hub', 'read_more', 'document_scanner', 'more_time', 'mark_email_unread', 'call_end',
    'clear_all', 'dialpad', 'phone_enabled', 'mark_chat_unread', 'cancel_presentation', '3p', 'call_made', 'screen_share', 'call_split', 'unsubscribe',
    'domain_verification', 'present_to_all', 'co_present', 'mark_chat_read', 'add_ic_call', 'phonelink_ring', 'call_received', 'stay_current_portrait', 'phonelink_lock', 'cell_tower',
    'phone_disabled', 'ring_volume', 'location_off', 'phonelink_setup', 'duo', 'stay_primary_portrait', 'swap_calls', 'voicemail', 'call_merge', 'phonelink_erase',
    'mobile_screen_share', 'person_add_disabled', 'domain_disabled', 'call_missed_outgoing', 'spoke', 'speaker_phone', 'desktop_access_disabled', 'cell_wifi', 'contact_emergency', 'mark_unread_chat_alt',
    'stop_screen_share', 'print_disabled', 'call_missed', 'pause_presentation', 'comments_disabled', 'dialer_sip', 'invert_colors_off', 'wifi_calling', 'rtt', 'portable_wifi_off',
    'send_time_extension', 'mail_lock', 'stay_current_landscape', 'sip', 'nat', 'key_off', 'stay_primary_landscape', 'no_sim', 'vpn_key_off',
  ];

  // Maps
  static readonly ANGULAR_MATERIAL_ICONS_MAPS = [
    'local_shipping', 'place', 'menu_book', 'local_offer', 'badge', 'map', 'category', 'restaurant', 'directions_car', 'local_fire_department', 
    'volunteer_activism', 'my_location', 'flight', 'local_mall', 'near_me', 'handyman', 'directions_run', 'restaurant_menu', 'layers', 'medical_services', 
    'directions_walk', 'local_hospital', 'lunch_dining', 'celebration', 'local_library', 'pin_drop', 'park', 'local_atm', 'local_activity', 'person_pin', 
    'design_services', 'directions_bus', 'local_cafe', 'rate_review', 'delivery_dining', 'local_police', 'directions_bike', 'fastfood', 'directions_car_filled', 'home_repair_service', 
    'zoom_out_map', 'cleaning_services', 'hotel', 'miscellaneous_services', 'local_phone', 'local_grocery_store', 'navigation', 'local_gas_station', 'diamond', 'train', 
    'person_pin_circle', 'local_parking', 'local_florist', 'factory', 'money', 'local_post_office', 'directions', 'two_wheeler', 'add_business', 'electrical_services', 
    'route', 'traffic', 'directions_boat', 'warehouse', 'local_bar', 'alt_route', 'agriculture', 'beenhere', 'emergency', 'pedal_bike', 
    '360', 'liquor', 'moving', 'local_airport', 'sailing', 'add_location_alt', 'local_dining', 'maps_ugc', 'local_taxi', 'trip_origin', 
    'local_laundry_service', 'ramen_dining', 'directions_bus_filled', 'local_drink', 'hail', 'local_printshop', 'theater_comedy', 'local_pizza', 'forest', 'not_listed_location', 
    'transfer_within_a_station', 'add_location', 'dinner_dining', 'bakery_dining', 'wine_bar', 'terrain', 'multiple_stop', 'takeout_dining', 'store_mall_directory', 'icecream', 
    'museum', 'nightlife', 'local_pharmacy', 'hardware', 'departure_board', 'set_meal', 'add_road', 'ev_station', 'location_pin', 'electric_car', 
    'local_see', 'festival', 'plumbing', 'medical_information', 'car_rental', 'layers_clear', 'attractions', 'edit_location', 'zoom_in_map', 'pest_control', 
    'local_convenience_store', 'run_circle', 'dry_cleaning', 'church', 'edit_road', 'edit_attributes', 'edit_location_alt', 'car_repair', 'wrong_location', 'moped', 
    'local_movies', 'directions_boat_filled', 'satellite', 'soup_kitchen', 'signpost', 'tram', 'taxi_alert', 'breakfast_dining', 'merge', 'straight', 
    'subway', 'atm', 'crisis_alert', 'transit_enterexit', 'brunch_dining', 'hvac', 'electric_bike', 'connecting_airports', 'directions_transit', 'egg', 
    'electric_scooter', 'safety_check', 'bus_alert', 'mode_of_travel', 'local_car_wash', 'local_hotel', 'stadium', 'castle', 'car_crash', 'streetview', 
    'mosque', 'directions_subway', 'compass_calibration', 'turn_right', 'electric_rickshaw', 'airline_stops', 'fork_right', 'directions_railway', 'no_meals', 'railway_alert', 
    'no_crash', 'electric_moped', 'local_play', 'turn_left', 'u_turn_left', 'airlines', 'pest_control_rodent', 'bike_scooter', 'egg_alt', 'near_me_disabled', 
    'snowmobile', 'tire_repair', 'directions_transit_filled', 'minor_crash', 'no_transfer', 'sos', 'flight_class', 'kebab_dining', 'directions_subway_filled', 'fort', 
    'temple_buddhist', 'directions_railway_filled', 'emergency_share', 'fire_truck', 'u_turn_right', 'temple_hindu', 'synagogue', 'fork_left', 'remove_road', 'screen_rotation_alt', 
    'turn_sharp_right', 'roundabout_right', 'turn_slight_right', 'turn_slight_left', 'emergency_recording', 'roundabout_left', 'turn_sharp_left', 'ramp_left', 'ramp_right', 'fire_hydrant_alt', 
    'no_meals_ouline',
  ];

  // File
  static readonly ANGULAR_MATERIAL_ICONS_FILE = [
    'file_download', 'file_upload', 'download', 'folder', 'grid_view', 'upload_file', 'cloud_upload', 'folder_open', 'cloud', 'text_snippet',
    'request_quote', 'cloud_download', 'drive_file_rename_outline', 'upload', 'attachment', 'download_for_offline', 'newspaper', 'create_new_folder', 'downloading', 'folder_shared',
    'cloud_done', 'cloud_queue', 'workspaces', 'topic', 'approval', 'download_done', 'cloud_off', 'file_open', 'drive_file_move', 'drive_folder_upload',
    'file_download_done', 'cloud_sync', 'attach_email', 'rule_folder', 'folder_zip', 'folder_copy', 'cloud_circle', 'snippet_folder', 'difference', 'file_download_off',
    'folder_delete', 'drive_file_move_rtl', 'folder_off', 'workspaces_filled', 'workspaces_outline', 'drive_file_move_outline', 'format_overline', 'file_upload_off',
  ];

  // Audio & Video
  static readonly ANGULAR_MATERIAL_ICONS_AUDIO_VIDEO = [
    'play_arrow', 'play_circle_filled', 'videocam', 'play_circle', 'mic', 'volume_up', 'pause', 'play_circle_outline', 'replay', 'volume_off',
    'library_books', 'skip_next', 'fiber_manual_record', 'speed', 'stop', 'movie', 'skip_previous', 'new_releases', 'playlist_add', 'loop',
    'equalizer', 'fast_forward', 'web', 'playlist_add_check', 'video_library', 'library_add', 'pause_circle', 'mic_off', 'stop_circle', 'subscriptions',
    'volume_mute', 'video_call', 'repeat', 'not_interested', 'shuffle', 'sort_by_alpha', 'fast_rewind', 'mic_none', 'library_music', 'volume_down',
    'videocam_off', 'recent_actors', 'web_asset', 'library_add_check', 'hearing', 'queue_music', 'pause_circle_filled', 'subtitles', 'pause_circle_outline', 'fiber_new',
    'note', 'av_timer', 'album', 'playlist_play', 'queue', 'games', 'radio', 'replay_circle_filled', 'branding_watermark', 'forward_10',
    'replay_10', 'closed_caption', 'video_settings', 'high_quality', 'featured_play_list', 'playlist_add_check_circle', 'control_camera', 'playlist_remove', 'add_to_queue', 'slow_motion_video',
    'repeat_one', 'airplay', 'call_to_action', 'snooze', 'hd', 'replay_30', 'repeat_on', 'closed_caption_off', 'featured_video', 'shuffle_on',
    'audio_file', 'forward_30', '5g', 'playlist_add_circle', 'music_video', 'interpreter_mode', 'queue_play_next', 'replay_5', 'video_file', 'art_track',
    'hearing_disabled', 'forward_5', 'explicit', 'video_label', '4k', 'fiber_smart_record', 'repeat_one_on', 'closed_caption_disabled', 'surround_sound', 'remove_from_queue',
    'play_disabled', 'web_asset_off', 'sd', 'lyrics', 'missed_video_call', '10k', 'fiber_pin', 'fiber_dvr', '4k_plus', '1k',
    '2k', '1k_plus', '8k', 'movie_edit', '5k', '8k_plus', '9k_plus', '3k', 'volume_down_alt', '5k_plus',
    '7k', '9k', '2k_plus', '3k_plus', '6k', '7k_plus', '6k_plus',
  ];

  // Toggle
  static readonly ANGULAR_MATERIAL_ICONS_TOGGLE = [
    'star', 'check_box', 'check_box_outline_blank', 'radio_button_unchecked', 'radio_button_checked', 'star_border', 'toggle_on', 'star_outline', 'toggle_off', 'star_half',
    'indeterminate_check_box', 'star_purple500', 'star_border_purple500',
  ];

  // Alert
  static readonly ANGULAR_MATERIAL_ICONS_ALERT = [
    'warning', 'error', 'error_outline', 'warning_amber', 'notification_important', 'add_alert', 'auto_delete',
  ];

  // Notification
  static readonly ANGULAR_MATERIAL_ICONS_NOTIFICATION = [
    'support_agent', 'wifi', 'account_tree', 'sync', 'priority_high', 'event_available', 'event_note', 'confirmation_number', 'sms', 'live_tv',
    'ondemand_video', 'drive_eta', 'wifi_off', 'event_busy', 'do_not_disturb_on', 'wc', 'more', 'power', 'do_not_disturb', 'sync_problem',
    'time_to_leave', 'do_disturb_on', 'vpn_lock', 'running_with_errors', 'enhanced_encryption', 'folder_special', 'do_disturb', 'sms_failed', 'network_check', 'phone_callback',
    'adb', 'phone_forwarded', 'system_update', 'power_off', 'personal_video', 'voice_chat', 'vibration', 'airline_seat_recline_normal', 'do_disturb_alt', 'do_not_disturb_alt',
    'sync_disabled', 'tap_and_play', 'no_encryption', 'sd_card', 'phone_missed', 'airline_seat_recline_extra', 'imagesearch_roller', 'mms', 'disc_full', 'sync_lock',
    'no_encryption_gmailerrorred', 'bluetooth_audio', 'sd_card_alert', 'sim_card_alert', 'do_not_disturb_off', 'phone_paused', 'airline_seat_individual_suite', 'do_disturb_off', 'phone_locked', 'airline_seat_flat',
    'network_locked', 'tv_off', 'phone_bluetooth_speaker', 'airline_seat_flat_angled', 'airline_seat_legroom_normal', 'directions_off', 'airline_seat_legroom_extra', 'airline_seat_legroom_reduced', 'add_call', 'video_chat',
  ];

  // Editor
  static readonly ANGULAR_MATERIAL_ICONS_EDITOR = [
    'attach_money', 'edit_note', 'format_list_bulleted', 'mode_edit', 'attach_file', 'monetization_on', 'post_add', 'bar_chart', 'checklist', 'drag_handle',
    'show_chart', 'insert_drive_file', 'format_quote', 'query_stats', 'format_list_numbered', 'table_chart', 'border_color', 'pie_chart', 'notes', 'checklist_rtl',
    'text_fields', 'format_bold', 'table_rows', 'publish', 'title', 'insert_emoticon', 'auto_graph', 'insert_photo', 'insert_chart_outlined', 'draw',
    'mode', 'mode_comment', 'functions', 'insert_link', 'mode_edit_outline', 'insert_invitation', 'horizontal_rule', 'format_align_left', 'format_italic', 'format_color_fill',
    'add_comment', 'insert_chart', 'linear_scale', 'stacked_line_chart', 'format_size', 'insert_comment', 'money_off', 'format_underlined', 'vertical_align_bottom', 'bubble_chart',
    'height', 'vertical_align_top', 'schema', 'format_align_center', 'square', 'format_paint', 'area_chart', 'format_color_text', 'format_align_right', 'scatter_plot',
    'format_list_numbered_rtl', 'highlight', 'data_object', 'format_align_justify', 'merge_type', 'add_chart', 'numbers', 'format_shapes', 'money_off_csred', 'pie_chart_outline',
    'format_indent_increase', 'short_text', 'move_up', 'format_color_reset', 'strikethrough_s', 'vertical_align_center', 'align_horizontal_left', 'hexagon', 'rectangle', 'move_down',
    'multiline_chart', 'score', 'border_all', 'text_increase', 'polyline', 'format_indent_decrease', 'format_clear', 'space_bar', 'format_line_spacing', 'horizontal_distribute',
    'candlestick_chart', 'align_vertical_bottom', 'format_list_bulleted_add', 'align_horizontal_center', 'vertical_distribute', 'align_horizontal_right', 'format_strikethrough', 'superscript', 'data_array', 'margin',
    'pentagon', 'wrap_text', 'align_vertical_top', 'subscript', 'border_clear', 'align_vertical_center', 'text_decrease', 'border_style', 'padding', 'border_outer',
    'line_axis', 'insert_page_break', 'shape_line', 'border_inner', 'border_left', 'format_textdirection_l_to_r', 'border_bottom', 'border_vertical', 'border_horizontal', 'format_textdirection_r_to_l',
    'border_top', 'border_right', 'pie_chart_outlined', 'type_specimen',
  ];

  // Hardware
  static readonly ANGULAR_MATERIAL_ICONS_HARDWARE = [
    'keyboard_arrow_down', 'phone_iphone', 'smartphone', 'keyboard_arrow_right', 'computer', 'security', 'desktop_windows', 'smart_display', 'keyboard_backspace', 'phone_android',
    'keyboard_arrow_up', 'keyboard_return', 'keyboard_double_arrow_right', 'laptop', 'smart_toy', 'keyboard_arrow_left', 'memory', 'headphones', 'point_of_sale', 'keyboard',
    'headset_mic', 'tv', 'keyboard_double_arrow_left', 'keyboard_double_arrow_down', 'mouse', 'developer_board', 'keyboard_voice', 'start', 'router', 'videogame_asset',
    'keyboard_double_arrow_up', 'cast_for_education', 'device_hub', 'headset', 'laptop_mac', 'cast', 'watch', 'tablet_mac', 'devices_other', 'desktop_mac',
    'keyboard_tab', 'laptop_chromebook', 'phonelink', 'monitor', 'speaker', 'toys', 'gamepad', 'sim_card', 'keyboard_alt', 'connected_tv',
    'tablet_android', 'cast_connected', 'laptop_windows', 'browser_updated', 'device_unknown', 'keyboard_hide', 'scanner', 'tablet', 'pallet', 'speaker_group',
    'earbuds', 'keyboard_capslock', 'headset_off', 'forklift', 'conveyor_belt', 'keyboard_command_key', 'home_max', 'trolley', 'headphones_battery', 'dock',
    'power_input', 'smart_screen', 'browser_not_supported', 'earbuds_battery', 'phonelink_off', 'home_mini', 'adf_scanner', 'front_loader', 'developer_board_off', 'videogame_asset_off',
    'keyboard_control_key', 'watch_off', 'keyboard_option_key',
  ];

  // Device
  static readonly ANGULAR_MATERIAL_ICONS_DEVICE = [
    'light_mode', 'restart_alt', 'dark_mode', 'task', 'summarize', 'password', 'sell', 'signal_cellular_alt', 'devices', 'settings_suggest',
    'quiz', 'widgets', 'storage', 'credit_score', 'thermostat', 'battery_full', 'gps_fixed', 'price_check', 'medication', 'pin',
    'gpp_good', 'battery_charging_full', 'price_change', 'reviews', 'fmd_good', 'tungsten', 'air', 'note_alt', 'bluetooth', 'monitor_heart',
    'graphic_eq', 'dvr', 'nightlight', 'sports_score', 'access_time', 'water', 'share_location', 'gpp_maybe', 'cable', 'location_searching',
    'cameraswitch', 'shortcut', 'airplane_ticket', 'wallpaper', 'radar', 'device_thermostat', 'discount', 'gpp_bad', 'data_usage', 'monitor_weight',
    'signal_wifi_4_bar', 'developer_mode', 'mode_night', 'wifi_tethering', 'battery_std', 'bloodtype', 'lan', 'signal_cellular_4_bar', 'fmd_bad', 'splitscreen',
    'flashlight_on', 'sim_card_download', 'network_wifi', 'access_time_filled', 'airplanemode_active', 'mobile_friendly', 'usb', 'send_to_mobile', 'battery_alert', 'lens_blur',
    'screen_search_desktop', 'signal_wifi_statusbar_4_bar', 'screen_rotation', 'signal_wifi_statusbar_connected_no_internet_4', 'gps_not_fixed', 'system_security_update_good', 'bluetooth_connected', 'battery_5_bar', 'nfc', 'remember_me',
    'mode_standby', 'pattern', 'brightness_high', 'battery_saver', 'play_lesson', 'data_saver_off', 'storm', 'data_saver_on', 'brightness_medium', 'bluetooth_searching',
    'signal_wifi_0_bar', 'grid_4x4', 'brightness_low', 'ad_units', 'screenshot', 'mobiledata_off', 'ssid_chart', 'network_cell', 'bluetooth_disabled', 'battery_4_bar',
    'hdr_auto', 'battery_0_bar', 'wifi_calling_3', 'security_update_good', 'battery_unknown', 'signal_wifi_off', 'battery_6_bar', 'settings_system_daydream', 'signal_wifi_bad', 'battery_3_bar',
    'access_alarms', 'signal_wifi_connected_no_internet_4', 'access_alarm', 'aod', 'medication_liquid', 'flashlight_off', 'signal_cellular_0_bar', 'add_to_home_screen', 'battery_1_bar', 'security_update',
    'gps_off', 'signal_wifi_statusbar_null', 'punch_clock', 'sd_storage', 'grid_3x3', '4g_mobiledata', 'reset_tv', 'brightness_auto', 'signal_cellular_connected_no_internet_4_bar', 'wifi_lock',
    'dataset', 'do_not_disturb_on_total_silence', 'battery_2_bar', 'nearby_error', 'screenshot_monitor', 'airplanemode_inactive', '1x_mobiledata', 'security_update_warning', 'phishing', 'signal_cellular_connected_no_internet_0_bar',
    'screen_lock_portrait', 'wifi_password', 'system_security_update_warning', 'system_security_update', 'wifi_tethering_off', 'edgesensor_high', 'signal_cellular_nodata', '30fps', '4g_plus_mobiledata', 'network_wifi_1_bar',
    'signal_cellular_off', 'signal_wifi_4_bar_lock', 'add_alarm', 'lte_mobiledata', 'location_disabled', 'signal_cellular_null', 'wifi_find', 'bluetooth_drive', 'mobile_off', 'network_wifi_3_bar',
    'media_bluetooth_on', 'rsvp', 'edgesensor_low', 'grid_goldenratio', '3g_mobiledata', 'usb_off', 'screen_lock_rotation', 'screen_lock_landscape', '60fps', 'network_wifi_2_bar',
    'lte_plus_mobiledata', 'timer_10_select', 'wifi_2_bar', 'signal_cellular_alt_1_bar', 'dataset_linked', 'signal_cellular_alt_2_bar', 'wifi_tethering_error', 'signal_cellular_no_sim', 'wifi_1_bar', 'wifi_channel',
    'g_mobiledata', 'timer_3_select', 'h_mobiledata', 'media_bluetooth_off', 'e_mobiledata', 'r_mobiledata', 'h_plus_mobiledata', 'hdr_on_select', 'hdr_auto_select', 'nearby_off',
    'hdr_off_select', 'devices_fold', 'fluorescent', 'macro_off',
  ];

  // Places
  static readonly ANGULAR_MATERIAL_ICONS_PLACES = [
    'storefront', 'apartment', 'fitness_center', 'business_center', 'spa', 'meeting_room', 'house', 'corporate_fare', 'ac_unit', 'cottage',
    'family_restroom', 'checkroom', 'other_houses', 'all_inclusive', 'grass', 'airport_shuttle', 'child_care', 'beach_access', 'pool', 'kitchen',
    'casino', 'holiday_village', 'room_service', 'roofing', 'room_preferences', 'sports_bar', 'free_breakfast', 'escalator_warning', 'bathtub', 'child_friendly',
    'foundation', 'food_bank', 'gite', 'villa', 'night_shelter', 'golf_course', 'no_photography', 'stairs', 'microwave', 'backpack',
    'elevator', 'wash', 'smoking_rooms', 'cabin', 'house_siding', 'hot_tub', 'countertops', 'water_damage', 'fire_extinguisher', 'carpenter',
    'charging_station', 'rv_hookup', 'baby_changing_station', 'soap', 'smoke_free', 'umbrella', 'do_not_touch', 'tapas', 'rice_bowl', 'tty',
    'fence', 'balcony', 'no_food', 'houseboat', 'bento', 'wheelchair_pickup', 'iron', 'bungalow', 'crib', 'chalet',
    'do_not_step', 'no_meeting_room', 'escalator', 'dry', 'stroller', 'no_drinks', 'no_cell', 'no_flash', 'no_backpack', 'no_stroller',
    'vaping_rooms', 'desk', 'vape_free',
  ];

  // Search
  static readonly ANGULAR_MATERIAL_ICONS_SEARCH = [
    'manage_search', 'feed', 'chair', 'bed', 'podcasts', 'coffee', 'shower', 'yard', 'window', 'light',
    'door_front', 'garage', 'dining', 'flatware', 'coffee_maker', 'blender', 'table_restaurant', 'bedroom_parent', 'camera_indoor', 'bedroom_baby',
    'bathroom', 'chair_alt', 'door_sliding', 'camera_outdoor', 'door_back', 'living', 'doorbell', 'bedroom_child', 'table_bar',
  ];

  // Home
  static readonly ANGULAR_MATERIAL_ICONS_HOME = [
    'sensor_door', 'electric_bolt', 'sunny', 'energy_savings_leaf', 'sensor_window', 'auto_mode', 'solar_power', 'shield_moon', 'shelves', 'oil_barrel',
    'wind_power', 'sensor_occupied', 'electric_meter', 'heat_pump', 'gas_meter', 'cloudy_snowing', 'propane_tank', 'mode_fan_off', 'sunny_snowing', 'roller_shades',
    'foggy', 'snowing', 'broadcast_on_personal', 'propane', 'blinds', 'roller_shades_closed', 'blinds_closed', 'curtains', 'vertical_shades', 'nest_cam_wired_stand',
    'vertical_shades_closed', 'curtains_closed', 'broadcast_on_home',
  ];

  static ANGULAR_MATERIAL_ICONS = [
    {category: 'Action', icons: this.ANGULAR_MATERIAL_ICONS_ACTION},
    {category: 'Navigation', icons: this.ANGULAR_MATERIAL_ICONS_NAVIGATION},
    {category: 'Social', icons: this.ANGULAR_MATERIAL_ICONS_SOCIAL},
    {category: 'Content', icons: this.ANGULAR_MATERIAL_ICONS_CONTENT},
    {category: 'Image', icons: this.ANGULAR_MATERIAL_ICONS_IMAGE},
    {category: 'Communication', icons: this.ANGULAR_MATERIAL_ICONS_COMMUNICATION},
    {category: 'Maps', icons: this.ANGULAR_MATERIAL_ICONS_MAPS},
    {category: 'File', icons: this.ANGULAR_MATERIAL_ICONS_FILE},
    {category: 'Audio & Video', icons: this.ANGULAR_MATERIAL_ICONS_AUDIO_VIDEO},
    {category: 'Toggle', icons: this.ANGULAR_MATERIAL_ICONS_TOGGLE},
    {category: 'Alert', icons: this.ANGULAR_MATERIAL_ICONS_ALERT},
    {category: 'Notification', icons: this.ANGULAR_MATERIAL_ICONS_NOTIFICATION},
    {category: 'Editor', icons: this.ANGULAR_MATERIAL_ICONS_EDITOR},
    {category: 'Hardware', icons: this.ANGULAR_MATERIAL_ICONS_HARDWARE},
    {category: 'Device', icons: this.ANGULAR_MATERIAL_ICONS_DEVICE},
    {category: 'Places', icons: this.ANGULAR_MATERIAL_ICONS_PLACES},
    {category: 'Search', icons: this.ANGULAR_MATERIAL_ICONS_SEARCH},
    {category: 'Home', icons: this.ANGULAR_MATERIAL_ICONS_HOME},
  ];

  // 入退場管理:通過口種別
  static readonly ENTRANCE_EXIT_GATE_TYPE_ENTRANCE: number = 1;    // 入場口
  static readonly ENTRANCE_EXIT_GATE_TYPE_EXIT: number = 2;        // 退場口
  static readonly ENTRANCE_EXIT_GATE_TYPE_EXHIBIT: number = 3;     // 展示物

  // SPLATS: API種別
  static readonly SPLATS_API_TYPE_SHARE: number = 1;               // 共有環境
  static readonly SPLATS_API_TYPE_PRODUCTION: number = 2;          // 本番環境
}
